import DashboardHeader from "@/components/DashboardHeader";
import SelectInput from "@/components/selectInput/SelectInput";
import SelectSearchInput from "@/components/selectInput/SelectSearchInput";
import deleteIcon from "../../../assets/icons/deleteIcon.svg";
import { FiEdit2 } from "react-icons/fi";
import {
  addOnsTypes,
  guestsPerBartenderDrop,
  PACKAGES_TYPES,
  SUPPLIES,
} from "@/constants/CompanyData";
import React, { useState, useEffect, useMemo, FC } from "react";
import { useForm } from "react-hook-form";
import { AddOnsCalInterface, AddOnsInterface } from "../interface";
import { PieChart } from "@/components/pieChart/Piechart";
import ToggleInput from "@/components/toggle/Toggle";

import "./Calculator.css";
import { API_ROUTES } from "@/services/environment";
import { useAppSelector } from "@/hooks/hook";
import { DELETE, GET, PATCH, POST_MULTIPART } from "@/services/api";
import { CustomSupply, Package, PackageType } from "@/interfaces/Package";

import Alert from "@/components/alert/Alert";
import useLoading from "@/hooks/useLoading";
import FormModal from "@/components/modals/FormModal";
import { FaCirclePlus } from "react-icons/fa6";
import { useDispatch } from "react-redux";
import { formStateChange } from "@/redux/slices/formSlice";
import useError from "@/hooks/useError ";
import Dropzone from "@/components/dropzone/DropZone";
import ImageUploadFunDropZone from "@/constants/utils/ImageUploadDropZoneFun";
import ChangesAlert from "@/components/alert/ChangesAlert";
import CustomSupplies from "./CustomSupplies";
import { avoidEmptyStringValidator, Button, convertDollarToCents, formatNumber, FormHookInput, Input, Loader, USFormatePriceWithDecimal, USFormatePriceWithoutDecimal } from "@thdinc/hpf-shared";
import { useWindowSize } from "@/hooks/useWindowSize";
import { convertCentsToDollars } from "@thdinc/hpf-shared";

interface Props {
  params?: {
    currentBusiness?: string;
    isCompanyCreation?: boolean;
    next?: () => void;
  };
}


type PackageForm = {
  packageName: string;
  prepTime: number;
  tipFee: number;
  bartenderCosts: number;
  deliveryFee: number;
  description: string;
  suppliesPrice: number;
  suppliesCosts: number;
};
const portableBar = "Portable Bar"
const iceCubes = "Ice and Coolers"
const defaultAddonImg = "https://happiest-prod-images.s3.amazonaws.com/1726851743496_White_background.png"
const defaultAddons: AddOnsCalInterface[] = [{
  name: portableBar,
  img: "https://dn16dhy0grblk.cloudfront.net/cutsomSupply/Portable%20Bars.png",
  type: "fixed",
  price: 3000,
  cost: 1000,
  id: "2",
  auto_include: true,
  description: "",
  is_btc_edit: false,
  min_price: 0,
  include_prep_time: false

},
{
  name: iceCubes,
  img: "https://dn16dhy0grblk.cloudfront.net/cutsomSupply/Ice%20Cubes.png",
  type: "guests",
  price: 100,
  cost: 100,
  id: "3",
  auto_include: true,
  description: "",
  is_btc_edit: false,
  min_price: 0,
  include_prep_time: false

},]
function getAddonPrice(
  addon: AddOnsCalInterface,
  guests: number,
  bartenders: number,
  numberOfHours: number,
  bartenderPrepTime: number
): number {
  switch (addon.type) {
    case "bartender":
      return Math.max(addon.price * bartenders, addon.min_price ?? 0);
    // return addon.price * bartenders;
    case "guests":
      return Math.max(addon.price * guests, addon.min_price ?? 0);
    // return addon.price * guests;
    case "hourly":
      if (addon.include_prep_time) {
        return Math.max(addon.price * (Number(numberOfHours) + Number(bartenderPrepTime) / 60), addon.min_price ?? 0);
      } else {
        return Math.max(addon.price * numberOfHours, addon.min_price ?? 0);
      }
    // return addon.price * numberOfHours;
    case "NumOfCocktails":
      return Math.max(addon.price * getNumberOfCocktails(guests, numberOfHours), addon.min_price ?? 0);
    // return addon.price * getNumberOfCocktails(guests, numberOfHours);
    case "fixed":
    default:
      return Math.max(addon.price, addon.min_price ?? 0);
    // return addon.price;
  }
}

function getAddonCost(
  addon: AddOnsCalInterface,
  guests: number,
  bartenders: number,
  numberOfHours: number
): number {
  switch (addon.type) {
    case "bartender":
      return addon.cost * bartenders;
    case "guests":
      return addon.cost * guests;
    case "hourly":
      return addon.cost * numberOfHours;
    case "NumOfCocktails":
      return addon.cost * getNumberOfCocktails(guests, numberOfHours);
    case "fixed":
    default:
      return addon.cost;
  }
}


export function getAddonsTotal(
  addons: AddOnsCalInterface[],
  guests: number,
  bartenders: number,
  numberofhours: number,
  bartenderPrepTime: number
): number {
  const totalAddonsPrice = addons.reduce((acc, addon) => {
    if (addon.auto_include) {
      acc += getAddonPrice(addon, guests, bartenders, numberofhours, bartenderPrepTime);
      return acc;
    } else {
      return acc;
    }
  }, 0);
  return totalAddonsPrice;
}
function getCustomSupplyTotalCost(
  customSupply: CustomSupply[],
  guests: number,
  bartenders: number,
  numberOfHours: number // Fixed casing
): number {
  return customSupply?.reduce((acc, supply) => {
    return acc + supply.cost * getNumberOfCocktails(guests, numberOfHours);
  }, 0);
}
function getCustomSupplyTotal(
  customSupply: CustomSupply[],
  guests: number,
  bartenders: number,
  numberOfHours: number // Fixed casing
): number {
  return customSupply?.reduce((acc, supply) => {
    return acc + supply.price * getNumberOfCocktails(guests, numberOfHours);
  }, 0);
}
export function getAddonsTotalCost(
  addons: AddOnsCalInterface[],
  guests: number,
  bartenders: number,
  numberofhours: number
): number {
  const totalAddonsPrice = addons.reduce((acc, addon) => {
    if (addon.auto_include) {
      acc += getAddonCost(addon, guests, bartenders, numberofhours);
      return acc;
    } else {
      return acc;
    }
  }, 0);
  return totalAddonsPrice;
}
const PLATFORM_SERVICE_FEE_BP = 750;
export function getPlatformServiceFee(amount: number) {
  return (amount * PLATFORM_SERVICE_FEE_BP) / 10000;
}
function getNumberOfBartenders(guests: number, guestsPerBartender: number) {
  return Math.ceil(guests / guestsPerBartender);
}
function getNumberOfCocktails(guests: number, numberOfHours: number) {
  const Intguests = Math.ceil(guests);
  const IntHours = Math.ceil(numberOfHours);
  return Intguests * (IntHours + 1);
}

function DynamicNumbers(startTime: number) {
  // Generate an array of numbers from 1 to 12

  const numbers = Array.from({ length: 12 }, (_, i) => i + Number(startTime));

  return (
    <div className="w-full md:flex hidden gap-4 justify-between ml-1">
      {numbers.map((number) => {
        if (
          (number >= 10 && number < 100) ||
          (number <= -10 && number > -100)
        ) {
          return (
            <span
              key={number}
              className="text-xs text-gray-500 dark:text-gray-400"
            >
              {number}
            </span>
          );
        } else {
          return (
            <span
              key={number}
              className="text-xs text-gray-500 dark:text-gray-400"
            >
              &nbsp;{number}
            </span>
          );
        }
      })}
    </div>
  );
}
const PriceCalculation: FC<Props> = ({ params }) => {
  const { roles } = useAppSelector((store: any) => store.user);
  const { width } = useWindowSize()
  const [hrToRegister, setHrToRegister] = useState(3);
  const [isNewPackage, setIsNewPackage] = useState<boolean>(true)
  const [addOns, setAddOns] = useState<AddOnsCalInterface[]>([]);
  const [addAddOnForm, setAddOnForm] = useState<boolean>(false);
  const [addNewPackageForm, setAddNewPackageForm] = useState<boolean>(false);
  const [packageFormEditForm, setPackageFormEditForm] =
    useState<boolean>(false);
  const [activeStatus, setActiveStatus] = useState<boolean>(false);
  const [addOnName, setAddOnName] = useState<string>("");
  const [addOnType, setAddOnType] = useState<string>("bartender");
  const [addOnPrice, setAddOnPrice] = useState("");
  const [addOnCost, setAddOnCost] = useState("");
  const [addOnMinPrice, setAddOnMinPrice] = useState("");
  const [isEditByBtC, setIsEditByBtC] = useState<boolean>(true);
  const [guest, setGuest] = useState(25);
  const [selectedGuests, setSelectedGuests] = useState(75);
  const [selectedGuestBeer, setSelectedGuestBeer] = useState(75);
  const [addOnError, setAddOnError] = useState<string>("");
  const [bartenderPrepTime, setBartenderPrepTime] = useState(60);
  // const [tipFee, setTipFee] = useState(0);
  const [bartenderCost, setBartenderCost] = useState(0);
  const [bartenderPrice, setBartenderPrice] = useState(0);
  const [bartenderTips, setBartenderTips] = useState(0);
  const [bartenderPriceP, setBartenderPriceP] = useState(0);
  const [deliveryCost, setDeliveryCost] = useState(0);
  const [additionalProfit, setAdditionalProfit] = useState(0);
  const [deliveryPrice, setDeliveryPrice] = useState(0);
  const [suppliesCosts, setSuppliesCosts] = useState(0);
  const [suppliesPrice, setSuppliesPrice] = useState(0);
  // const [distance, setDistance] = useState(30);
  // const [mileageCost, setMileageCost] = useState(0);
  // const [mileagePrice, setMileagePrice] = useState(0);
  const [disableDistance, setDisableDistance] = useState(false);
  const [Bpp, setBpp] = useState(0);
  const [Mpp, setMpp] = useState(0);
  const [SPP, setSPP] = useState(0);
  const [showBpp, setShowBpp] = useState(true);
  const [showBtp, setShowBtp] = useState(false);
  const [showCMP, setShowCMP] = useState(true);
  const [showCSP, setShowCSP] = useState(true);
  const [tipJar, setTipJar] = useState(false);
  const [fixedPrice, setFixedPrice] = useState(0);
  const [minPackageTime, setMinPackageTime] = useState(3);
  const [modal, setModal] = useState<boolean>(false);
  const [deleteLoader, setDeleteLoader] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [deletePackageId, setDeletePackageId] = useState<string | undefined>('');
  const {
    getRevnuePackage,
    singlePackageApi,
    packageGarnishes,
    addPackageApi,
    packageDefaultSupplies,
    packages
  } = API_ROUTES;
  const [packageList, setPackageList] = useState<Package[]>([]);
  const [curPackage, setCurPackage] = useState<Package | null>();
  const [minPackagePrice, setMinPackagePrice] = useState(0);
  const [minBartenderTip, setMinBartenderTip] = useState(0);
  const { isLoading, startLoading, stopLoading } = useLoading();
  const { refreshToken, business_id } = useAppSelector((store) => store.user);
  // const [selectedGuestsInput, setSelectedGuestsInput] = useState(75);

  const [BP, setBP] = useState(true);
  const [CP, setCP] = useState(true);
  const [CPF, setCPF] = useState(true);
  const [bTips, setBTips] = useState(true);
  const [mAddOnTotal, setMaddOnTotal] = useState(true);
  const [mIceAndCoolerTotal, setmIceAndCoolerTotal] = useState(true);
  const [CST, setCST] = useState(true);
  const [GPB, setGPB] = useState(false);
  const [marketingExpense, setMarketingExpense] = useState(0);
  const [insuranceExpense, setInsuranceExpense] = useState(0);
  const [addOnIsEdit, setAddOnIsEdit] = useState<boolean>(false);
  const [addOnImage, setAddOnImage] = useState<{ file?: File; img: string }>();
  const [addOnDesc, setAddOnDesc] = useState<string>("");
  const [includeInPackage, setIncludeInPackage] = useState<boolean>(false);
  const [addOnPrepTime, setAddOnPrepTime] = useState<boolean>(false);
  const [suppliesList, setSuppliesList] = useState([]); // all supplies list
  const [totalSuppliesList, setTotalSuppliesList] = useState(SUPPLIES); // all supplies list
  const [selectedSupplies, setSelectedSupplies] = useState<string[]>([]); // selected list
  const [selectedType, setSelectedType] = useState<string>("standard");
  const [addSupplyForm, setAddSupplyForm] = useState<boolean>(false);
  const [supplyInput, setSupplyInput] = useState<string>("");
  const closeAddOnModal = () => setAddOnForm(false);
  const [addOnId, setAddOnId] = useState<string>();
  const [btp, setbtp] = useState(0);
  const dispatch = useDispatch();
  const [error, setCustomError] = useError();
  const [addError, setAddError] = useState<string>("");
  const [supplyDescription, setSupplyDescription] = useState<string>("");
  const [defaultSupplies, setDefaultSupplies] = useState<CustomSupply[] | null>(null);
  const [customSupplies, setCustomSupplies] = useState<CustomSupply[] | null>(null);
  const [canSubmit, setCanSubmit] = useState<boolean>(true);
  const [customSupTotalPlus, setCustomSupTotalPlus] = useState<number>(0);
  const {
    register,
    watch,
    trigger,
    formState: { errors: packageFormErrors },
    setValue,
    reset
  } = useForm<PackageForm>({
    defaultValues: { prepTime: 60 },
  });
  const businessId = params?.currentBusiness
    ? params
    : useAppSelector((store) => store.business);
  useEffect(() => {
    getPackageList();
    // getGarnishes();
  }, []);
  const getGarnishes = async () => {
    const { data } = await GET(`${packageGarnishes}`, refreshToken);
    const supplies = [...data.map(
      (item: any) => item.charAt(0).toUpperCase() + item.slice(1)
    )]
    const selectedSet = new Set(selectedSupplies);
    const remainingSupplies = supplies.filter(item => !selectedSet.has(item));
    const sortedArray = [...selectedSet, ...remainingSupplies]
    setTotalSuppliesList([...sortedArray]);
  };
  useEffect(() => {
    let data: AddOnsCalInterface[] = []
    if (curPackage) {
      setBartenderCost(curPackage.bartenderCost / 100);
      setMinBartenderTip(curPackage.minTips / 100)
      setBartenderPrice(
        (curPackage.bartenderPrice - curPackage.bartenderCost) / 100
      );
      setSelectedGuests(curPackage.guestsPerBartender);
      // setSelectedGuestsInput(curPackage.guestsPerBartender);
      setBartenderPrepTime(curPackage.prepMins);
      setSuppliesCosts(curPackage.suppliesCost / 100);
      setSuppliesPrice(
        (curPackage.suppliesPrice - curPackage.suppliesCost) / 100
      );
      setMinPackageTime(curPackage.minHours);
      setBartenderPrepTime(curPackage.prepMins);
      setDeliveryCost(curPackage.deliveryFee / 100);
      setInsuranceExpense(curPackage.insuranceExpense / 100);
      setMarketingExpense(curPackage.marketingExpense / 100);
      setTipJar(!curPackage.tipsOptional);
      setSupplyDescription(curPackage.description);
      setAdditionalProfit(curPackage.additionalProfit / 100);
      setActiveStatus(curPackage.isActive);
      setSelectedType(curPackage.type);
      setValue("packageName", curPackage.name);
      // setSelectedGuestCocktails(curPackage.guestsPerCocktail)
      setSelectedGuestBeer(curPackage.guestsPerBeer || 75)
      let customSupTotal = 0
      curPackage?.customSupply && setCustomSupplies(curPackage?.customSupply.map((i) => {
        i.profit = i?.price - i?.cost
        customSupTotal += i.price
        return i
      }))
      setCustomSupTotalPlus(parseFloat((customSupTotal / 100).toFixed(2)));
      setBpp(
        Math.round(
          ((curPackage.bartenderPrice - curPackage.bartenderCost) /
            curPackage.bartenderCost) *
          100 *
          100
        ) / 100
      );
      setSPP(
        Math.round(
          ((curPackage.suppliesPrice - curPackage.suppliesCost) /
            curPackage.suppliesCost) *
          100 *
          100
        ) / 100
      );
      if (curPackage.isTipPercentage) {
        setShowBtp(curPackage.isTipPercentage);
        setbtp((curPackage.tipsFee || 0) / 100);
      } else {
        setShowBtp(curPackage.isTipPercentage);
        setBartenderTips((curPackage.tipsFee || 0) / 100);
      }
      if (curPackage.minPrice > 0) {
        setMinPackagePrice(curPackage.minPrice / 100);
      } else {
        setMinPackagePrice(0);
      }
      setHrToRegister(curPackage.minHours);
      if (curPackage.minPrice > 0) {
        // setHrToRegister(1);
        setMinPackageTime(1);
      }
      curPackage && setSelectedSupplies([
        ...curPackage.supplies.map(
          (item: any) => item.charAt(0).toUpperCase() + item.slice(1)
        ),
      ]);
      if (curPackage.addons) {
        const addDefaultAddons = true
        // curPackage.addons.map((i) => {
        //   if ((i.name === portableBar || i.name === iceCubes) && curPackage.addons) {
        //     addDefaultAddons = false
        //     console.log('if ran')
        //     // data =curPackage.addons
        //   }
        // })
        if (addDefaultAddons) {
          // data = [...curPackage.addons, ...defaultAddons.map((i) => {
          //   if (selectedType === 'custom_package') {
          //     i.auto_include = false
          //   } else {
          //     i.auto_include = true

          //   }
          //   return i
          // })]
          setSupplyDescription(
            `${generateDescription(selectedType === 'custom_package' ? [] : curPackage.supplies)}\n${generateAddsOnDescription([
              ...curPackage.addons,
            ])}`
          );
        } else {
          data = curPackage.addons
          setSupplyDescription(
            `${generateDescription(selectedType === 'custom_package' ? [] : curPackage.supplies)}\n${generateAddsOnDescription([
              ...data,
            ])}`
          );
        }
        setAddOns(curPackage.addons);
      } else {
        //   setAddOns([...defaultAddons.map((i) => {
        //     if (selectedType === 'custom_package') {
        //       i.auto_include = false
        //     } else {
        //       i.auto_include = true

        //     }
        //     return i
        //   })]
        // );
      }
    }
  }, [curPackage]);

  const getPackageList = async (packageId?: string) => {
    try {
      const res = await GET(
        `${getRevnuePackage}/?business_id=${params ? businessId?.currentBusiness : business_id}`,
        refreshToken
      );
      if (res.data) {
        if (res.data?.length === 0) {
          setAddNewPackageForm(true);
        }
        setPackageList(res.data);
        if (packageId) {
          const cur = res.data.find((p: Package) => p.id === packageId);
          setCurPackage(cur);
        } else {
          setCurPackage(res.data[0]);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const deletePackage = async (packageId?: string) => {
    if (packageId) {
      try {
        setDeleteLoader(true)
        const res = await DELETE(`${packages}/${packageId}`, refreshToken);
        if (res.data) {
          resetAddOnForm();
          setAddOnIsEdit(false);
          addNewPackagefn();
          reset()
          getPackageList()
        }
      } catch (error) {
        Alert({ type: "error", message: "Error: Could not delete the selected package" });
        console.log(error);
      } finally {
        setDeleteLoader(false)
        setDeleteModal(false)
      }
    } else {
      Alert({ type: "error", message: "Error: Could not delete the selected package" });
    }
  };


  const { deliveryCostTotal, deliveryPriceTotal } = useMemo(() => {
    // let mileagecost = 0;
    // let mileageprice = 0;
    // if (mileageCost) {
    //   mileagecost = Number(mileageCost);
    // }
    // if (mileagePrice) {
    //   mileageprice = Number(mileagePrice);
    // }
    // const mileageCostCal: number = Math.ceil(
    //   mileagecost * Math.max(distance - 30, 0) * 2
    // );
    const deliveryCostTotal = Number(deliveryCost);
    const deliveryPriceTotal = Number(deliveryCost);
    return { deliveryCostTotal, deliveryPriceTotal };
  }, [deliveryCost, deliveryPrice]);
  const {
    numberOfBartenders,
    getnumberOfCocktails,
    addOnTotal,
    addonsTotalCost,
    customSupplyTotal,
    customSupplyTotalCost,
    mandatoryAddOnsTotal,
    mandatoryIceAndCooler,
    mandatoryAddonsTotalCost,
    mandatoryIceAndCoolerCost
  } = useMemo(() => {
    const guestList = GPB ? selectedGuestBeer : selectedGuests
    const numberOfBartenders: number = getNumberOfBartenders(
      guest,
      guestList
    );
    const getnumberOfCocktails = getNumberOfCocktails(guest, hrToRegister);
    const addOnsTotal = getAddonsTotal(
      addOns?.filter(addOn => addOn.is_btc_edit),
      guest,
      numberOfBartenders,
      hrToRegister,
      bartenderPrepTime
    );
    const portableAddOn: AddOnsCalInterface[] = addOns?.filter(addOn => (!addOn.is_btc_edit && addOn.name == 'Portable Bar'))
    const IceAndCoolerAddOn: AddOnsCalInterface[] = addOns?.filter(addOn => (!addOn.is_btc_edit && addOn.name == 'Ice and Coolers'))
    const mandatoryAddOnsTotal = mAddOnTotal ? getAddonsTotal(
      [{ ...portableAddOn[0], auto_include: true }],
      guest,
      numberOfBartenders,
      hrToRegister,
      bartenderPrepTime
    ) / 100 : 0;
    const mandatoryIceAndCooler = mIceAndCoolerTotal ? getAddonsTotal(
      [{ ...IceAndCoolerAddOn[0], auto_include: true }],
      guest,
      numberOfBartenders,
      hrToRegister,
      bartenderPrepTime
    ) / 100 : 0;

    const mandatoryAddonsTotalCost =
      mAddOnTotal ? getAddonsTotalCost(addOns?.filter(addOn => (!addOn.is_btc_edit && addOn.name == 'Portable Bar')), guest, numberOfBartenders, hrToRegister) / 100 : 0;
    const mandatoryIceAndCoolerCost =
      mIceAndCoolerTotal ? getAddonsTotalCost(addOns?.filter(addOn => (!addOn.is_btc_edit && addOn.name == 'Ice and Coolers')), guest, numberOfBartenders, hrToRegister) / 100 : 0;
    const addonsTotalCost =
      getAddonsTotalCost(addOns?.filter(addOn => addOn.is_btc_edit), guest, numberOfBartenders, hrToRegister) / 100;

    const customSupplyTotal = CST ? getCustomSupplyTotal(customSupplies || [], guest, numberOfBartenders, hrToRegister) / 100 : 0;
    const customSupplyTotalCost = CST ? getCustomSupplyTotalCost(customSupplies || [], guest, numberOfBartenders, hrToRegister) / 100 : 0;
    const addOnTotal = addOnsTotal / 100;
    return {
      numberOfBartenders,
      getnumberOfCocktails,
      addOnTotal,
      addonsTotalCost,
      customSupplyTotal,
      customSupplyTotalCost,
      mandatoryAddOnsTotal,
      mandatoryIceAndCooler,
      mandatoryAddonsTotalCost,
      mandatoryIceAndCoolerCost
    };
  }, [guest, hrToRegister, selectedGuests, addOns, fixedPrice, customSupplies, CST, GPB, mAddOnTotal, mIceAndCoolerTotal]);

  const {
    profit,
    Revenue,
    Cost,
    packageTotalCost,
    packageTotalPrice,
    serviceSubTotalCost,
    serviceSubTotalPrice,
    totalProfit,
    platFormTotal,
    TotalSum,
    minPriceEffect,
    TipsTotal,
  } = useMemo(() => {
    const suppliescosts = Number(suppliesCosts);
    const suppliesprice = Number(suppliesPrice);
    // if (!suppliesCosts || !suppliesPrice ){
    //   suppliescosts = 0;
    //   suppliesprice = 0;
    // }
    const bartenderPriceCostTotal: number =
      Number(bartenderPrice) + Number(bartenderCost);
    const totalSupplyPrices = Number(suppliesprice) + Number(suppliescosts);
    // console.log('bartenderPriceTotal', bartenderPriceTotal);
    const packageTotalCost =
      Number(numberOfBartenders) *
      Number(bartenderCost) *
      (Number(hrToRegister) + Number(bartenderPrepTime) / 60) +
      Number(getnumberOfCocktails) * Number(suppliescosts);
    const packageTotalPrice =
      Number(numberOfBartenders) *
      Number(bartenderPriceCostTotal) *
      (Number(hrToRegister) + Number(bartenderPrepTime) / 60) +
      Number(getnumberOfCocktails) * totalSupplyPrices;
    const bartenderPriceTotal =
      Number(numberOfBartenders) *
      Number(bartenderPriceCostTotal) *
      (Number(hrToRegister) + Number(bartenderPrepTime) / 60);
    let serviceSubTotalCost =
      Number(packageTotalCost) +
      Number(deliveryCostTotal) +
      Number(addonsTotalCost) +
      Number(mandatoryAddonsTotalCost) +
      Number(mandatoryIceAndCoolerCost) +
      Number(marketingExpense) +
      Number(insuranceExpense);
    const tipServiceTotal = Number(packageTotalPrice) +
      Number(deliveryPriceTotal) + Number(additionalProfit) +
      Number(marketingExpense) +
      Number(insuranceExpense) + Number(addOnTotal) + Number(customSupplyTotal) + Number(mandatoryAddOnsTotal) + Number(mandatoryIceAndCooler)
    const TipsTotal = bTips ? Math.max(!tipJar
      ? showBtp
        ? (btp / 100) * tipServiceTotal
        : bartenderTips * guest
      : 0, minBartenderTip) : 0;
    const maxPrice = Math.max(
      Number(packageTotalPrice) +
      Number(deliveryPriceTotal) +
      Number(TipsTotal) +
      Number(additionalProfit) +
      Number(marketingExpense) +
      Number(insuranceExpense),
      Number(minPackagePrice)
    );
    let serviceSubTotalPrice = maxPrice + Number(addOnTotal) + Number(customSupplyTotal) + Number(mandatoryAddOnsTotal) + Number(mandatoryIceAndCooler);
    // const platFormTotal = CPF ? getPlatformServiceFee(serviceSubTotalPrice) : 0;
    //   Number(addOnTotal);
    const platFormTotal = CPF ? getPlatformServiceFee(serviceSubTotalPrice) : 0;
    serviceSubTotalPrice += platFormTotal;
    serviceSubTotalCost += Number(customSupplyTotal);
    serviceSubTotalCost += platFormTotal;

    const minPriceEffect =
      Number(minPackagePrice) >
        Number(packageTotalPrice) + Number(deliveryPriceTotal)
        ? serviceSubTotalPrice -
        (Number(packageTotalPrice) +
          Number(deliveryPriceTotal) +
          Number(addOnTotal) +
          Number(mandatoryAddOnsTotal) +
          Number(mandatoryIceAndCooler) +
          Number(additionalProfit) +
          Number(platFormTotal) +
          Number(TipsTotal) +
          Number(marketingExpense) +
          Number(insuranceExpense))
        : 0;
    // console.log('serviceSubTotalPrice', serviceSubTotalPrice);
    const totalProfit =
      Number(serviceSubTotalPrice) - Number(serviceSubTotalCost);
    const TotalSum =
      Number(serviceSubTotalPrice.toFixed(2)) +
      Number(serviceSubTotalCost.toFixed(2)) +
      Number(totalProfit.toFixed(2));
    let profit = 0;
    let Revenue = 0;
    let Cost = 0;
    if (TotalSum > 0 && serviceSubTotalPrice > 0 && serviceSubTotalCost > 0) {
      profit = (totalProfit / TotalSum) * 100;
      Revenue = (serviceSubTotalPrice / TotalSum) * 100;
      Cost = (serviceSubTotalCost / TotalSum) * 100;
    } else {
      profit = 0;
    }
    return {
      profit,
      Revenue,
      Cost,
      packageTotalCost,
      packageTotalPrice,
      serviceSubTotalCost,
      serviceSubTotalPrice,
      totalProfit,
      platFormTotal,
      TotalSum,
      minPriceEffect,
      TipsTotal,
    };
  }, [
    numberOfBartenders,
    bartenderCost,
    bartenderPrepTime,
    hrToRegister,
    getnumberOfCocktails,
    suppliesCosts,
    suppliesPrice,
    deliveryCostTotal,
    addOnTotal,
    bartenderPrice,
    deliveryPriceTotal,
    additionalProfit,
    minPackagePrice,
    CPF,
    insuranceExpense,
    marketingExpense,
    bartenderTips,
    tipJar,
    showBtp,
    btp,
    customSupplyTotal,
    customSupplyTotalCost,
    minBartenderTip,
    mAddOnTotal,
    bTips,
    mIceAndCoolerTotal
  ]);
  const {
    formState: { errors },
  } = useForm<PackageForm>({ defaultValues: { prepTime: 60 } });

  const deleteAddOn = (id: string) => {
    const updated = addOns.filter((item, index) => item.id !== id);
    setAddOns(updated);
    setSupplyDescription(
      `${generateDescription(selectedSupplies)}\n${generateAddsOnDescription([
        ...updated,
      ])}`
    );
  };

  const updatePackage = async () => {
    try {
      startLoading();
      const payload = {
        minTips: minBartenderTip
          ? convertDollarToCents(minBartenderTip.toString())
          : 0,
        bartenderCost: bartenderCost
          ? convertDollarToCents(bartenderCost.toString())
          : 0,
        bartenderPrice: convertDollarToCents(
          (Number(bartenderPrice) + Number(bartenderCost)).toString()
        ),
        deliveryFee: deliveryCost
          ? convertDollarToCents(deliveryCost.toString())
          : 0,
        description: supplyDescription,
        startTime: curPackage?.startTime,
        endTime: curPackage?.endTime,
        image: curPackage?.image,
        isActive: activeStatus,
        mileageFee: curPackage?.mileageFee ? curPackage?.mileageFee : 0,
        minPrice: minPackagePrice
          ? convertDollarToCents(minPackagePrice.toString())
          : 0,
        bartenderPrepTime: bartenderPrepTime ? bartenderPrepTime : 0,
        name: curPackage?.name,
        supply: selectedSupplies,
        suppliesCost: suppliesCosts
          ? convertDollarToCents(suppliesCosts.toString())
          : 0,
        suppliesFee: suppliesPrice
          ? convertDollarToCents(suppliesPrice.toString())
          : 0,
        hourToRegister: minPackageTime ? minPackageTime : 0,
        tips: !tipJar,
        tipsFee: !tipJar
          ? showBtp
            ? convertDollarToCents(btp.toString())
            : convertDollarToCents(bartenderTips.toString())
          : 0,
        guestPerBartender: selectedGuests ? selectedGuests : 0,
        type: curPackage?.type,
        marketingExpense: Math.round((Number(marketingExpense) * 100)),
        insuranceExpense: Math.round(Number(insuranceExpense) * 100),
        additionalProfit: Math.round(Number(additionalProfit) * 100),
        isTipPercentage: showBtp,
        packageAddons: addOns.map((item: any) => {
          return {
            id: item.id,
            name: item.name,
            auto_include: item.auto_include,
            price: formatNumber(item.price),
            cost: formatNumber(item.cost),
            type: item.type,
            description: item.description,
            addonImage: item.image ? item.image : item.addonImage,
          };
        }),
        business_id: curPackage?.businessId,
      };
      if (bartenderCost <= 0) {
        Alert({ type: "error", message: "Bartender Price cannot be zero" });
        stopLoading();
        return;
      }
      if (selectedType !== 'custom_package' && suppliesCosts <= 0) {
        Alert({ type: "error", message: "Cocktail Price cannot be zero" });
        stopLoading();
        return;
      }
      // if (Number(suppliesCosts) + Number(suppliesPrice) <= 0) {
      //   Alert({ type: "error", message: "Cocktail Price cannot be zero" });
      //   stopLoading();
      //   return;
      // }
      if (selectedSupplies.length === 0 && selectedType !== 'custom_package') {
        Alert({ type: "error", message: "Supplies required" });
        stopLoading();
        return false;
      }
      if (deliveryCost <= 0) {
        Alert({ type: "error", message: "Fixed Expense required" });
        stopLoading();
        return false;
      }
      // if (
      //   !tipJar &&
      //   ((showBtp && btp < 0) || (!showBtp && bartenderTips <= 0))
      // ) {
      //   Alert({
      //     type: "error",
      //     message: "Tips Required",
      //   });
      //   stopLoading();
      //   return false;
      // }
      const formData = new FormData();
      const appendToFormData = (payload: Record<string, any>) => {
        for (const key in payload) {
          if (Object.prototype.hasOwnProperty.call(payload, key)) {
            if (key === "packageAddons") {
              // Handle nested array (packageAddons) separately
              // payload[key].forEach((addon: any, index: number) => {
              //   console.log('append',addon)
              //   // formData.append(`packageAddons[${index}][id]`, addon.id);
              //   formData.append(`packageAddons[${index}][name]`, addon.name);
              //   formData.append(
              //     `packageAddons[${index}][auto_include]`,
              //     addon.auto_include
              //   );
              //   formData.append(`packageAddons[${index}][price]`, addon.price);
              //   formData.append(`packageAddons[${index}][cost]`, addon.cost);
              //   formData.append(`packageAddons[${index}][type]`, addon.type);

              //   formData.append(
              //     `packageAddons[${index}][description]`,
              //     addon.description
              //   );
              //   if (addon.addonImage && addon.addonImage.file) {
              //     formData.append(
              //       `packageAddons[${index}][addonImage]`,
              //       addon.addonImage.file
              //     );
              //   } else {
              //     formData.append(
              //       `packageAddons[${index}][addonImage]`,
              //       addon.img
              //     );
              //   }
              // });
            } else if (key === "image" && payload[key]) {
              // Handle file (image)
              formData.append(key, payload[key] as Blob);
            } else if (key === "supply") {
              payload[key].forEach((item: string, index: number) => {
                formData.append(`supply[${index}]`, item);
              });
            } else {
              // Append other fields
              formData.append(key, String(payload[key]));
            }

          }
        }
      };
      // append addons
      addOns.forEach((addon: any, index: number) => {
        console.log('append', addon)
        // formData.append(`packageAddons[${index}][id]`, addon.id);
        formData.append(`packageAddons[${index}][name]`, addon.name);
        formData.append(
          `packageAddons[${index}][auto_include]`,
          addon.auto_include
        );
        formData.append(`packageAddons[${index}][price]`, addon.price);
        formData.append(`packageAddons[${index}][cost]`, addon.cost);
        formData.append(`packageAddons[${index}][type]`, addon.type);
        formData.append(`packageAddons[${index}][min_price]`, addon.min_price);
        formData.append(`packageAddons[${index}][include_prep_time]`, addon.include_prep_time);
        addon.is_btc_edit !== undefined && formData.append(`packageAddons[${index}][is_btc_edit]`, addon.is_btc_edit);
        formData.append(
          `packageAddons[${index}][description]`,
          addon.description
        );
        if (addon.addonImage && addon.addonImage.file) {
          formData.append(
            `packageAddons[${index}][addonImage]`,
            addon.addonImage.file
          );
        } else {
          formData.append(
            `packageAddons[${index}][addonImage]`,
            addon.img
          );
        }
      });
      // In case of custom package
      if (selectedType === 'custom_package') {
        customSupplies?.forEach((item, index) => {
          formData.append(`customSupply[${index}][name]`, item?.name as string);
          formData.append(`customSupply[${index}][image]`, item?.image as string);
          formData.append(`customSupply[${index}][type]`, item?.type as string);
          formData.append(`customSupply[${index}][cost]`, (Math.round(item?.cost))?.toString() as string);
          formData.append(`customSupply[${index}][profit]`, (Math.round(item?.profit))?.toString() as string);
          // formData.append(`customSupply[${index}][image]`, item?.file as File);
          formData.append(`customSupply[${index}][description]`, item?.description as string);
          formData.append(`customSupply[${index}][isBeer]`, JSON.stringify(item?.isBeer) as string);
          formData.append(`customSupply[${index}][isCocktail]`, JSON.stringify(item?.isCocktail) as string);
          formData.append(`customSupply[${index}][isWine]`, JSON.stringify(item?.isWine) as string);
          formData.append(`customSupply[${index}][byCustomer]`, JSON.stringify(item?.byCustomer) as string);
        });
        formData.append('guestsPerBeer', selectedGuestBeer.toString())
      }

      appendToFormData(payload);
      for (const pair of formData.entries()) {
        console.log(pair[0] + ": " + pair[1]);
      }
      if (curPackage?.id) {
        const res = await PATCH(
          singlePackageApi + `/${curPackage?.id}`,
          formData,
          refreshToken
        );
        if (res.data.success) {
          Alert({ type: "success", message: res?.data?.message });
          stopLoading();
          params?.isCompanyCreation && params.next && params?.next();
        } else {
          stopLoading();
          Alert({ type: "error", message: res?.data?.message });
        }
      } else {
        const res = await POST_MULTIPART(addPackageApi, formData, refreshToken);
        console.log(res);
        if (res.data.success) {
          setModal(false);
          getPackageList(res.data?.packageId);
          Alert({ type: "success", message: res?.data?.message });
          stopLoading();
          params?.isCompanyCreation && params.next && params?.next();
        } else {
          setModal(false);
          stopLoading();
          Alert({ type: "error", message: res?.data?.message });
        }
      }
    } catch (err) {
      console.log(err)

    } finally {
      stopLoading();

    }
  };
  const addNewPackagefn = async () => {
    const isValid = await trigger("packageName");
    const newPackageObj: Package = {
      is_active: false,
      guests_per_bartender: 25,
      // guestsPerCocktail: 25,
      guestsPerBeer: 25,
      additionalProfit: 0,
      addons: defaultAddons.map((_) => {
        if (selectedType === 'custom_package') {
          _.auto_include = false
        }
        return _
      }) as any,
      bartenderCost: 0,
      bartenderPrice: 0,
      minTips: 0,
      businessId: businessId.currentBusiness || "",
      createdAt: "",
      deliveryFee: 0,
      description: "",
      endTime: "24:00:00",
      guestsPerBartender: 25,
      id: "",
      image: "",
      insuranceExpense: 0,
      isActive: true,
      marketingExpense: 0,
      mileageFee: 0,
      minHours: 3,
      minPrice: 0,
      name: watch("packageName"),
      prepMins: 60,
      startTime: "00:00:00",
      supplies: [],
      suppliesCost: 0,
      suppliesPrice: 0,
      tipsFee: 0,
      tipsOptional: true,
      type: selectedType as PackageType,
      updatedAt: "",
      isTipPercentage: true,
    };
    if (isValid) {
      if (params?.isCompanyCreation) {
        if (curPackage && curPackage.id) {
          setAddNewPackageForm(false);
          const newPackageObj: Package = {
            is_active: false,
            guests_per_bartender: 25,
            // guestsPerCocktail: 25,
            guestsPerBeer: 25,
            additionalProfit: 0,
            addons: [],
            bartenderCost: 0,
            bartenderPrice: 0,
            businessId: businessId.currentBusiness || "",
            createdAt: "",
            deliveryFee: 0,
            description: "",
            endTime: "24:00:00",
            guestsPerBartender: 25,
            id: "",
            image: "",
            insuranceExpense: 0,
            isActive: true,
            marketingExpense: 0,
            mileageFee: 0,
            minHours: 3,
            minPrice: 0,
            name: watch("packageName"),
            prepMins: 60,
            startTime: "00:00:00",
            supplies: [],
            suppliesCost: 0,
            suppliesPrice: 0,
            tipsFee: 0,
            tipsOptional: false,
            isTipPercentage: false,
            type: selectedType as PackageType,
            updatedAt: "",
            minTips: 0
          };
          setPackageList([...packageList, newPackageObj]);
          setCurPackage(newPackageObj);
        } else {
          const newObject: any = {
            ...newPackageObj,
            name: watch("packageName"),
          };
          setCurPackage(newObject);
          setPackageList((prev) => [
            ...prev.filter((item) => item?.id !== ""),
            newObject,
          ]);
          setPackageFormEditForm(false);
          setAddNewPackageForm(false);
          return;
        }
      }
      if (curPackage && curPackage.id && packageFormEditForm) {
        const newObject: any = {
          ...curPackage,
          name: watch("packageName"),
          type: selectedType as PackageType,
          isActive: activeStatus,
        };
        setCurPackage(newObject);
        setPackageList((prev) => [
          ...prev.filter((item) => item?.id !== curPackage.id),
          newObject,
        ]);
      } else {
        const newObject: any = {
          ...newPackageObj,
          name: watch("packageName"),
        };
        setCurPackage(newObject);
        setPackageList((prev) => [
          ...prev.filter((item) => item?.id !== ""),
          newObject,
        ]);
      }
      setPackageFormEditForm(false);
      setAddNewPackageForm(false);
    }
  };
  const addAddOn = () => {
    dispatch(formStateChange(true));
    if (addOnName == "") {
      setAddOnError("Name is required");
      return;
    }
    if (
      addOnCost == "" ||
      parseInt(addOnCost) < 0 ||
      parseInt(addOnCost) > 999
    ) {
      setAddOnError("Enter valid cost (0-999)");
      return;
    }
    const intCost = parseFloat(addOnCost).toFixed(2);
    const intMinPrice = parseFloat(addOnMinPrice).toFixed(2);
    setAddOnError("");
    const addonsPriceInteger = addOnPrice ? parseFloat(parseFloat(addOnPrice).toFixed(2)) : 0;
    const date = new Date();
    const obj = {
      id: date.toString(),
      name: addOnName,
      type: addOnType,
      price: parseFloat((addonsPriceInteger * 100 + parseFloat(intCost) * 100).toFixed(2)),
      // price:parseFloat(( addonsPriceInteger * 100 + parseFloat(addOnCost) * 100).toFixed(2)),
      cost: parseFloat((parseFloat(intCost) * 100).toFixed(2)),
      description: addOnDesc,
      addonImage: addOnImage?.file ? addOnImage : undefined,
      auto_include: includeInPackage,
      include_prep_time: addOnPrepTime,
      img: !addOnImage?.file ? defaultAddonImg : '',
      is_btc_edit: true,
      min_price: parseFloat((parseFloat(intMinPrice) * 100).toFixed(2)) || 0,
    };
    setAddOns([...addOns, obj]);
    setSupplyDescription(
      generateDescription(selectedSupplies) +
      "\n" +
      generateAddsOnDescription([...addOns, obj])
    );
    setAddOnForm(false);
    setAddOnName("");
    setAddOnType("bartender");
    setAddOnPrice("");
    setAddOnCost("");
    setAddOnMinPrice("")
    setAddOnDesc("");
    setAddOnImage({ img: "" });
    setIncludeInPackage(false);
    setAddOnPrepTime(false);
  };
  const updateAddOn = () => {
    dispatch(formStateChange(true));
    const intCost = addOnCost ? parseFloat(addOnCost).toFixed(2) : 0
    const intMinPrice = addOnPrice ? parseFloat(addOnMinPrice).toFixed(2) : 0
    // const intCost = parseFloat(addOnCost)
    // check for default if the update item is default
    let isDefualt = false
    addOns.map((_) => {
      if (_.id === addOnId) {
        console.log('matched', _)
        isDefualt = _.is_btc_edit || false
      }
      return _
    })
    const filteredAddOn = addOns.filter((item: any) => item.id !== addOnId);
    // In case user update the image of add on
    // const addonsPriceInteger = addOnPrice ? parseFloat(addOnPrice) : 0;
    const addonsPriceInteger = addOnPrice ? parseFloat(parseFloat(addOnPrice).toFixed(2)) : 0;
    const date = new Date();
    let updatedAddons = []
    if (addOnImage?.file) {
      updatedAddons = [
        ...filteredAddOn,
        {
          id: date.toString(),
          name: addOnName,
          price: parseFloat((addonsPriceInteger * 100 + Number(intCost) * 100).toFixed(2)),
          cost: Number(intCost) * 100,
          addonImage: { ...addOnImage, file: addOnImage.file },
          description: addOnDesc,
          auto_include: includeInPackage,
          include_prep_time: addOnPrepTime,
          type: addOnType,
          is_btc_edit: isDefualt,
          min_price: Number(intMinPrice) * 100
        },
      ]
    } else {
      updatedAddons = [
        ...filteredAddOn,
        {
          id: date.toString(),
          name: addOnName,
          price: parseFloat((addonsPriceInteger * 100 + Number(intCost) * 100).toFixed(2)),
          cost: Number(intCost) * 100,
          img: addOnImage?.img,
          description: addOnDesc,
          auto_include: includeInPackage,
          include_prep_time: addOnPrepTime,
          type: addOnType,
          is_btc_edit: isDefualt,
          min_price: Number(intMinPrice) * 100
        },
      ]
    }
    setAddOns(updatedAddons)
    setAddOnForm(false);
    setAddOnIsEdit(false);
    resetAddOnForm();
    setSupplyDescription(
      generateDescription(selectedSupplies) +
      "\n" +
      generateAddsOnDescription(updatedAddons)
    );
  };
  const editAddonForm = (item: any) => {
    dispatch(formStateChange(true));
    const {
      name,
      img,
      price,
      type,
      id,
      description,
      auto_include,
      cost,
      addonImage,
      is_btc_edit,
      min_price,
      include_prep_time
    } = item;
    // if form is open edit mod;
    if (!addAddOnForm) {
      console.log("min_price--------------->", min_price, cost);
      setAddOnId(id);
      addonImage ? setAddOnImage(addonImage) : setAddOnImage({ img });
      setAddOnName(name);
      setAddOnPrice(((price - cost) / 100).toString());
      setAddOnCost((cost / 100).toString());
      setAddOnMinPrice((min_price / 100).toString());
      setAddOnPrepTime(include_prep_time);
      setAddOnType(type);
      setIncludeInPackage(auto_include);
      setAddOnDesc(description);
      setAddOnIsEdit(true);
      setIsEditByBtC(is_btc_edit)
    } else {
      resetAddOnForm();
      setAddOnIsEdit(false);
    }
    setAddOnForm(!addAddOnForm);
  };
  const resetAddOnForm = () => {
    setAddOnName("");
    setAddOnDesc("");
    setAddOnPrice("");
    setAddOnCost("");
    setAddOnMinPrice("");
    setAddOnType("bartender");
    setIncludeInPackage(false);
    setAddOnPrepTime(false);
    setAddOnImage({ img: "" });
    setIsEditByBtC(true)

  };
  const uploadAddOnImg = (file: any) => {
    dispatch(formStateChange(true));
    console.log(file);
    try {
      const f = ImageUploadFunDropZone(file);
      if (f) {
        setAddOnImage({ img: URL.createObjectURL(f), file: f });
        // setCustomError("dp", "");
      }
    } catch (error: any) {
      console.log("error", error.message);
      setCustomError("dp", error.message);
    }
  };
  const removeAddOnImage = () => {
    setAddOnImage({ img: "" });
  };
  const selectSupply = (checked: boolean, name: string) => {
    setSelectedSupplies((prev) => {
      const updatedSupplies = checked
        ? prev.filter((s) => s !== name) // Remove if checked
        : [...prev, name]; // Add if unchecked

      setSupplyDescription(
        `${generateDescription(updatedSupplies)}\n${generateAddsOnDescription([
          ...addOns,
        ])}`
      );
      return updatedSupplies;
    });
  };
  const generateDescription = (supplies: string[]) => {
    if (supplies.length === 0) {
      return "";
    }
    const supply = `Includes:\n→ ${supplies.join("\n→ ")}`;
    return supply;
  };
  const generateCustomSupplyDesc = (customSupplies: string[]) => {
    if (customSupplies.length === 0) {
      return "";
    }
    const supply = `Custom Supplies:\n→ ${customSupplies.join("\n→ ")}`;
    return supply;
  }
  const generateAddsOnDescription = (array: AddOnsCalInterface[]) => {
    //generates a description from the array of add ons
    console.log("arrays", array);
    if (array.length == 0) {
      return "";
    }
    const included = array
      .filter((item: any) => {
        if (item.auto_include) {
          return item.name;
        }
      })
      .map((item) => item.name);
    const exclded = array
      .filter((item: any) => {
        if (!item.auto_include) {
          return item.name;
        }
      })
      .map((item) => item.name);
    return `${exclded.length > 0
      ? `Add-ons (for an additional charge):
  → ${exclded.join("\n→ ")}`
      : ""
      }
  ${included.length > 0
        ? `Add-ons (Included):
  → ${included.join("\n→ ")}`
        : ""
      }
  `;
  };
  const addNewSupplyTab = () => {
    if (supplyInput) {
      setTotalSuppliesList((prev) => [...prev, supplyInput]);
      setAddSupplyForm(false);
    } else {
      setAddError("Supply name cannot be empty.");
    }
  };
  useEffect(() => {
    if (selectedType === 'custom_package') {
      setValue('packageName', 'Customized Package')
      setSelectedSupplies([])
      // setAddOns(addOns.map((i) => {
      //   if (i.name === iceCubes || i.name === portableBar) {
      //     i.auto_include = false
      //   }
      //   return i
      // }))
      // // changing auto include status
      // setAddOns(addOns.map((i) => {
      //   if (i.name === iceCubes || i.name === portableBar) {
      //     i.auto_include = false
      //   }
      //   return i
      // }))
    }
    else if (selectedType === 'standard') {
      setValue('packageName', '')
      // populate supplies
      curPackage && setSelectedSupplies([
        ...curPackage.supplies.map(
          (item: any) => item.charAt(0).toUpperCase() + item.slice(1)
        ),
      ]);
      // setCanSubmit(true)
      // setAddOns(addOns.map((i) => {
      //   if (i.name === iceCubes || i.name === portableBar) {
      //     i.auto_include = true
      //   }
      //   return i
      // }))
      // // changing auto include status
      // setAddOns(addOns.map((i) => {
      //   if (i.name === iceCubes || i.name === portableBar) {
      //     i.auto_include = true
      //   }
      //   return i
      // }))
      getGarnishes();
    } else {
      setValue('packageName', '')
    }
    curPackage && setSupplyDescription(
      `${generateDescription(selectedType === 'custom_package' ? [] : curPackage.supplies)}\n${generateAddsOnDescription(addOns)}`
    );
    if (selectedType != 'custom_package') {
      setCST(false)
    }
    // if (selectedType == 'custom_package') {
    //   setMinPackagePrice(0)
    // }
  }, [selectedType])

  useEffect(() => {
    // Get default supploes
    const getDefaultSupplies = async () => {
      try {
        const res = await GET(packageDefaultSupplies, refreshToken)
        // setCustomSupplies(res.data)
        setCustomSupplies(res.data.map((i: CustomSupply) => {
          i.profit = i?.price - i?.cost
          // i.price = parseFloat((i.price/100).toFixed(2))
          return i
        }))
      } catch (error) {
        console.log(error)
      }
    }
    //  selectedType === 'custom_package' &&  getDefaultSupplies()
    selectedType === 'custom_package' && !curPackage?.customSupply && getDefaultSupplies()

  }, [selectedType])
  const editDefaultSupplyPrice = (
    e: React.FocusEvent<HTMLInputElement>,
    id: string,
    type: "cost" | "profit" | "isActive"
  ) => {
    let validate = true;
    let val = e.target.value;

    // Clamp only max, and format to 2 decimals if needed
    if (parseFloat(val) > 999) {
      val = "999";
    } else if (val.includes(".") && val.split(".")[1].length > 2) {
      val = parseFloat(val).toFixed(2).toString();
    } else {
      val = val.toString();
    }

    const filtered = customSupplies?.map((item) => {
      if (item.id === id && type === "cost") {
        item.cost = parseFloat(val) * 100;
        item.price = parseFloat(((item.cost + item.profit)).toFixed(2));
      } else if (item.id === id && type === "profit") {
        item.profit = parseFloat(val) * 100;
        item.price = parseFloat(((item.cost + item.profit)).toFixed(2));
      } else if (item.id === id && type === "isActive") {
        item.isActive = !item?.isActive;
      }

      // validation logic
      if (
        isNaN(item.cost) ||
        isNaN(item.profit) ||
        item.profit < 0 // disallow negative profit
      ) {
        // setCanSubmit(false);
        validate = false;
      }

      return item;
    });

    // setCanSubmit(validate);
    if (filtered) {
      setCustomSupplies(filtered);

      const totalPrice = filtered.reduce((sum, item) => {
        return sum + (item.price || 0);
      }, 0);

      // convert cents to dollars if needed
      setCustomSupTotalPlus(parseFloat((totalPrice / 100).toFixed(2)));
    }
  };

  return (
    <div>
      <div className="relative">
        <div className="flex gap-2">
          <DashboardHeader title="Price Calculator"></DashboardHeader>
          {/* <img
            onClick={resetCalulator}
            src={refreshImg}
            className="transition-all hover:rotate-45  w-7 cursor-pointer"
            alt="refresh"
          /> */}
        </div>
        <div className=" top-0 w-full pt-4 pb-4  z-10 shadow-primary-gray gap-7">
          <div className=" flex md:flex-row flex-wrap  w-full justify-start gap-5  mx-2 items-stretch ">
            <div className="flex-1   p-5 rounded-2xl bg-white min-w-48">
              <div>
                <p className=" font-semibold ">Total Revenue</p>
                <p className="font-semibold text-3xl mb-2 mt-1">
                  ${`${USFormatePriceWithDecimal(serviceSubTotalPrice)}`}
                </p>
              </div>
              <div className="flex flex-col gap-1 ">
                <div className="flex justify-between">
                  <div className="flex flex-row gap-2 mb-[-8px]">
                    <p className="text-xs font-semibold ">Bartending Price: </p>
                    {/* <ToggleInput
                      checked={BP}
                      onChange={() => {
                        setBP(!BP);
                      }}
                    /> */}
                  </div>
                  <p className="text-xs font-semibold">
                    $
                    {USFormatePriceWithoutDecimal(
                      (Number(bartenderCost) + Number(bartenderPrice)) *
                      numberOfBartenders *
                      (Number(hrToRegister) + Number(bartenderPrepTime) / 60)
                    )}
                  </p>
                </div>
                <div className="flex justify-between">
                  <div className="flex flex-row gap-2 mb-[-8px]">
                    <p className="text-xs font-semibold ">Cocktails Price: </p>
                    {/* <ToggleInput
                      checked={CP}
                      onChange={() => {
                        setCP(!CP);
                      }}
                    /> */}
                  </div>
                  <p className="text-xs font-semibold">
                    $
                    {USFormatePriceWithDecimal(
                      (Number(suppliesCosts) + Number(suppliesPrice)) *
                      Number(getnumberOfCocktails)
                    )}
                  </p>
                </div>
                <div className="flex justify-between">
                  <p className="text-xs font-semibold">Additional Profit:</p>
                  <p className="text-xs font-semibold">
                    ${USFormatePriceWithDecimal(Number(additionalProfit))}
                  </p>
                </div>
                <div className="flex justify-between">
                  <p className="text-xs font-semibold">Add-ons Total:</p>
                  <p className="text-xs font-semibold">
                    ${USFormatePriceWithDecimal(addOnTotal)}
                  </p>
                </div>
                <div className="flex justify-between">
                  <p className="text-xs font-semibold">Additional Expense:</p>
                  <p className="text-xs font-semibold">
                    ${USFormatePriceWithDecimal(deliveryPriceTotal)}
                  </p>
                </div>
                <div className="flex justify-between">
                  <p className="text-xs font-semibold">Min Price Effect:</p>
                  <p className="text-xs font-semibold">
                    ${USFormatePriceWithDecimal(minPriceEffect)}
                  </p>
                </div>
                <div className="flex justify-between">
                  <p className="text-xs font-semibold">Insurance Expense:</p>
                  <p className="text-xs font-semibold">
                    {" "}
                    ${USFormatePriceWithDecimal(insuranceExpense)}
                  </p>
                </div>
                <div className="flex justify-between">
                  <p className="text-xs font-semibold">Marketing Expense:</p>
                  <p className="text-xs font-semibold">
                    ${USFormatePriceWithDecimal(marketingExpense)}
                  </p>
                </div>
                <div className="flex justify-between">
                  <div className="flex flex-row gap-2 mb-[-8px]">
                    <p className="text-xs font-semibold">
                      Bartender Tips:
                    </p>
                    <ToggleInput
                      checked={bTips}
                      onChange={() => {
                        setBTips(!bTips);
                      }}
                    />
                  </div>
                  <p className="text-xs font-semibold">
                    ${USFormatePriceWithDecimal(TipsTotal)}
                  </p>
                </div>
                <div className="flex justify-between">
                  <div className="flex flex-row gap-2 mb-[-8px]">
                    <p className="text-xs font-semibold">
                      Customer Platform Fee:
                    </p>
                    <ToggleInput
                      checked={CPF}
                      onChange={() => {
                        setCPF(!CPF);
                      }}
                    />
                  </div>
                  <p className="text-xs font-semibold">
                    ${USFormatePriceWithDecimal(isNaN(platFormTotal) ? 0 : platFormTotal)}
                  </p>
                </div>
                <div className="flex justify-between">
                  <div className="flex flex-row gap-2 mb-[-8px]">
                    <p className="text-xs font-semibold">
                      Mandatory Portable Bar:
                    </p>
                    <ToggleInput
                      checked={mAddOnTotal}
                      onChange={() => {
                        setMaddOnTotal(!mAddOnTotal);
                      }}
                    />
                  </div>
                  <p className="text-xs font-semibold">
                    ${USFormatePriceWithDecimal(isNaN(mandatoryAddOnsTotal) ? 0 : mandatoryAddOnsTotal)}
                  </p>
                </div>
                <div className="flex justify-between">
                  <div className="flex flex-row gap-2 mb-[-8px]">
                    <p className="text-xs font-semibold">
                      Mandatory Ice and Cooler:
                    </p>
                    <ToggleInput
                      checked={mIceAndCoolerTotal}
                      onChange={() => {
                        setmIceAndCoolerTotal(!mIceAndCoolerTotal);
                      }}
                    />
                  </div>
                  <p className="text-xs font-semibold">
                    ${USFormatePriceWithDecimal(isNaN(mandatoryIceAndCooler) ? 0 : mandatoryIceAndCooler)}
                  </p>
                </div>
                {selectedType == 'custom_package' && <div className="flex justify-between">
                  <div className="flex flex-row gap-2">
                    <p className="text-xs font-semibold">
                      Custom Supply Total
                    </p>
                    <ToggleInput
                      checked={CST}
                      onChange={() => {
                        setCST(!CST);
                      }}
                    />
                  </div>
                  <p className="text-xs font-semibold">
                    ${USFormatePriceWithDecimal(customSupplyTotal)}
                  </p>
                </div>}

                {/* <p className="text-xs font-semibold">
                  Tip Revenue: {tipTotal}
                </p> */}
              </div>
            </div>
            <div className="flex-1   p-5 rounded-2xl bg-white min-w-48">
              <div className="">
                <p className=" font-semibold">Cost/Expense</p>
                <p className="font-semibold text-3xl mb-2 mt-1">
                  ${`${USFormatePriceWithDecimal(serviceSubTotalCost)}`}
                </p>
              </div>
              <div>
                <div className="flex flex-col gap-1 ">
                  <div className="flex justify-between">
                    <p className="text-xs font-semibold">Bartending Cost: </p>
                    <p className="text-xs font-semibold">
                      $
                      {USFormatePriceWithDecimal(
                        bartenderCost *
                        numberOfBartenders *
                        (Number(hrToRegister) +
                          Number(bartenderPrepTime) / 60)
                      )}
                    </p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-xs font-semibold">Cocktail Cost: </p>
                    <p className="text-xs font-semibold">
                      $
                      {USFormatePriceWithDecimal(
                        suppliesCosts * getnumberOfCocktails
                      )}
                    </p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-xs font-semibold">Platform Fee:</p>
                    <p className="text-xs font-semibold">${0.0}</p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-xs font-semibold">Add-ons Cost:</p>
                    <p className="text-xs font-semibold">
                      ${USFormatePriceWithDecimal(addonsTotalCost)}
                    </p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-xs font-semibold">Additional Expense:</p>

                    <p className="text-xs font-semibold">
                      ${USFormatePriceWithDecimal(deliveryPriceTotal)}
                    </p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-xs font-semibold">Min Price Effect:</p>

                    <p className="text-xs font-semibold">${0.0}</p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-xs font-semibold">Insurance Expense:</p>
                    <p className="text-xs font-semibold">
                      ${USFormatePriceWithDecimal(insuranceExpense)}
                    </p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-xs font-semibold">Marketing Expense:</p>
                    <p className="text-xs font-semibold">
                      ${USFormatePriceWithDecimal(marketingExpense)}
                    </p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-xs font-semibold">Bartender Tips:</p>
                    <p className="text-xs font-semibold">${0.0}</p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-xs font-semibold">
                      Customer Platform Fee:
                    </p>
                    <p className="text-xs font-semibold">
                      ${USFormatePriceWithDecimal(isNaN(platFormTotal) ? 0 : platFormTotal)}
                    </p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-xs font-semibold">Mandatory Portable Bar Cost:</p>
                    <p className="text-xs font-semibold">
                      ${USFormatePriceWithDecimal(mandatoryAddonsTotalCost)}
                    </p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-xs font-semibold">Mandatory Ice and Cooler Cost:</p>
                    <p className="text-xs font-semibold">
                      ${USFormatePriceWithDecimal(mandatoryIceAndCoolerCost)}
                    </p>
                  </div>
                  {selectedType == 'custom_package' && <div className="flex justify-between">
                    <p className="text-xs font-semibold">
                      Custom Supply Total
                    </p>
                    <p className="text-xs font-semibold">
                      ${USFormatePriceWithDecimal(customSupplyTotalCost)}
                    </p>
                  </div>}
                </div>
              </div>
            </div>
            <div className="flex-1   p-5 rounded-2xl bg-white min-w-48">
              <div>
                <p className=" font-semibold ">Profit</p>
                <p className="font-semibold text-3xl mt-1 mb-2">
                  ${`${USFormatePriceWithDecimal(totalProfit)}`}
                </p>
              </div>
              <div className="flex flex-col gap-1">
                <div className="flex justify-between">
                  <p className="text-xs font-semibold">
                    Bartending Service Profit:{" "}
                  </p>
                  <p className="text-xs font-semibold">
                    $
                    {USFormatePriceWithDecimal(
                      bartenderPrice *
                      numberOfBartenders *
                      (Number(hrToRegister) + Number(bartenderPrepTime) / 60)
                    )}
                  </p>
                </div>
                <div className="flex justify-between">
                  <p className="text-xs font-semibold">
                    Profit from Cocktails:{" "}
                  </p>
                  <p className="text-xs font-semibold">
                    $
                    {USFormatePriceWithDecimal(
                      suppliesPrice * getnumberOfCocktails
                    )}
                  </p>
                </div>
                <div className="flex justify-between">
                  <p className="text-xs font-semibold">
                    Additional Profit - Platform Fee:{" "}
                  </p>
                  <p className="text-xs font-semibold">
                    ${USFormatePriceWithDecimal(additionalProfit)}
                  </p>
                </div>
                <div className="flex justify-between">
                  <p className="text-xs font-semibold">Add-ons Profit:</p>
                  <p className="text-xs font-semibold">
                    ${USFormatePriceWithDecimal(addOnTotal - addonsTotalCost)}
                  </p>
                </div>
                <div className="flex justify-between">
                  <p className="text-xs font-semibold">Additional Expense:</p>
                  <p className="text-xs font-semibold">${0.0}</p>
                </div>
                <div className="flex justify-between">
                  <p className="text-xs font-semibold">Min Price Effect:</p>
                  <p className="text-xs font-semibold">
                    ${USFormatePriceWithDecimal(minPriceEffect)}
                  </p>
                </div>
                <div className="flex justify-between">
                  <p className="text-xs font-semibold">Insurance Expense:</p>
                  <p className="text-xs font-semibold">${0.0}</p>
                </div>
                <div className="flex justify-between">
                  <p className="text-xs font-semibold">Marketing Expense:</p>
                  <p className="text-xs font-semibold">${0.0}</p>
                </div>
                <div className="flex justify-between">
                  <p className="text-xs font-semibold">Bartender Tips:</p>
                  <p className="text-xs font-semibold">
                    ${USFormatePriceWithDecimal(TipsTotal)}
                  </p>
                </div>
                <div className="flex justify-between">
                  <p className="text-xs font-semibold">
                    Customer Platform Fee:
                  </p>
                  <p className="text-xs font-semibold">${"0.0"}</p>
                </div>
                <div className="flex justify-between">
                  <p className="text-xs font-semibold">Mandatory Portable Bar Profit:</p>
                  <p className="text-xs font-semibold">
                    ${USFormatePriceWithDecimal(mandatoryAddOnsTotal - mandatoryAddonsTotalCost)}
                  </p>
                </div>
                <div className="flex justify-between">
                  <p className="text-xs font-semibold">Mandatory Ice and Cooler Profit:</p>
                  <p className="text-xs font-semibold">
                    ${USFormatePriceWithDecimal(mandatoryIceAndCooler - mandatoryIceAndCoolerCost)}
                  </p>
                </div>
                {selectedType == 'custom_package' && <div className="flex justify-between">
                  <p className="text-xs font-semibold">
                    Custom Supply Total:
                  </p>
                  <p className="text-xs font-semibold">  ${USFormatePriceWithDecimal(customSupplyTotal - customSupplyTotalCost)}</p>
                </div>}
              </div>
            </div>
          </div>
        </div>
        <div className="w-full  rounded-2xl  p-5   flex md:flex-row flex-col  bg-white items-center gap-4">
          <div className="flex flex-row ">
            <div className="w-full flex justify-center flex-row gap-4 items-center">
              <div className="w-full h-72 flex justify-center items-center">
                <PieChart
                  Profit={profit as number}
                  Revenue={Revenue as number}
                  Cost={Cost as number}
                  label="%"
                />
              </div>
            </div>
            <div></div>
          </div>
          <div className=" w-full bg-p-gray p-3 rounded-2xl flex flex-col gap-4">
            <div>
              <div className=" font-semibold text-xs my-1 flex justify-between">
                <p>Number of Guests ({guest})</p>
                <p className="text-base">Total Number of Cocktails ({getnumberOfCocktails})</p>
              </div>
              <div className="relative">
                <label htmlFor="labels-range-input" className="sr-only">
                  Labels range
                </label>
                <input
                  id="labels-range-input"
                  type="range"
                  value={guest}
                  onChange={(e: any) => setGuest(e.target.value)}
                  min={25}
                  step={25}
                  max={400}
                  className="w-full h-1 rounded-lg appearance-none cursor-pointer bg-primary-red"
                />
                <div className="w-full  gap-1 justify-between ml-1 md:flex hidden">
                  <div className="text-xs text-gray-500 dark:text-gray-400  ">
                    25&nbsp;
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400  ">
                    50&nbsp;
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400  ">
                    75&nbsp;
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400  ">
                    100
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400  ">
                    125
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400  ">
                    150
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400  ">
                    175
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400  ">
                    200
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400  ">
                    225
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400  ">
                    250
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400  ">
                    275
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400  ">
                    300
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400  ">
                    325
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400  ">
                    350
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400  ">
                    375
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400  ">
                    400
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full ">
              <div className="font-semibold text-xs my-1">
                Number of hours ({hrToRegister})
              </div>
              <div className="relative mb-3">
                <label htmlFor="labels-range-input" className="sr-only">
                  Labels range
                </label>
                <input
                  id="labels-range-input"
                  type="range"
                  min={Number(minPackageTime)}
                  max={Number(minPackageTime) + 11}
                  step={1}
                  value={hrToRegister}
                  className="w-full h-1 bg-primary-red rounded-lg appearance-none cursor-pointer "
                  onChange={(e: any) => setHrToRegister(e.target.value)}
                />
                {DynamicNumbers(minPackageTime)}

              </div>
            </div>
          </div>
        </div>
        <div className="w-full flex mt-5 flex-col-reverse sm:flex-row-reverse">
          {packageList?.length > 0 && (
            <div className="flex flex-row-reverse self-start">
              <div
                className="cursor-pointer flex gap-3 bg-p-gray rounded-full p-2 justify-center items-center"
                onClick={() => {
                  //set form values
                  setValue("packageName", curPackage?.name ?? "");
                  setSelectedType(curPackage?.type ?? PackageType.Standard);
                  setActiveStatus(curPackage?.isActive ?? false);
                  // // open modal
                  setPackageFormEditForm(true);
                }}
              >
                <FiEdit2 size={14} />
              </div>
              {curPackage?.id && <div
                className="cursor-pointer flex gap-3 bg-p-gray rounded-full p-2 justify-center items-center"
                onClick={() => {
                  setDeleteModal(true);
                  setDeletePackageId(curPackage?.id)
                }}
              >
                <img src={deleteIcon} className="min-w-3" />
              </div>}
              <select
                className="select-wrapper text-sm rounded-full cursor-pointer bg-white py-[12.5px]"
                onChange={(e) => {
                  const cur = packageList.find(
                    (p: Package) => p.id === e.target.value
                  );
                  setAddOns([])
                  setCurPackage(cur);
                }}
                value={curPackage?.id}
              >
                {packageList.map((r: Package) => {
                  return (
                    <option key={r.id} value={r.id}>
                      {r.name}
                    </option>
                  );
                })}
              </select>
            </div>
          )}
          <div
            onClick={() => {
              //reset form values
              setValue("packageName", "");
              setSelectedType(PackageType.Standard);
              setActiveStatus(true);
              //open modal
              setAddNewPackageForm(true);
            }}
            className="bg-black text-white cursor-pointer rounded-full mr-3 py-2 px-6 w-36 flex mb-2 items-center gap-1"
          >
            <span className="text-lg">+</span> Add New
          </div>
        </div>
        <div className="flex md:flex-row flex-col gap-5  mt-2 ">
          <div className="flex flex-col gap-5 mb-5 md:w-3/6">
            <div className="w-full bg-white rounded-2xl p-5 flex flex-col  ">
              <p className="md:text-xl text-lg font-bold mb-2 mt-2">
                About your Bartender
              </p>
              <div className="">
                {selectedType !== 'custom_package' && <div className="flex gap-4 w-full bg-p-gray p-3 rounded-2xl">
                  <div className="w-full">
                    <div className=" font-semibold text-sm my-2 flex justify-between flex-col lg:flex-row items-center">
                      <p>How many guests per bartender?</p>
                      <div className="flex items-center gap-2 justify-between">
                        <div className=" text-xs  focus:outline-none  focus:ring-1 focus:ring-primary-red  font-semibold">
                          Guests
                        </div>
                        <SelectInput
                          classes="max-w-40"
                          bg="bg-white"
                          disabled={false}
                          value={selectedGuests}
                          onChange={(e: string) => {
                            const selectedValue = e;
                            // setSelectedGuestsInput(Number(selectedValue));
                            setSelectedGuests(Number(selectedValue));
                          }}
                          options={guestsPerBartenderDrop}
                        />

                      </div>
                    </div>
                  </div>
                </div>}
                {selectedType === 'custom_package' && <div className="flex gap-4 w-full">
                </div>}
                {
                  selectedType === 'custom_package' &&
                  <div className="w-full">
                    <div className=" font-semibold text-sm flex justify-between items-center flex-col lg:flex-row bg-p-gray p-3 rounded-2xl">
                      <p>How many guests per bartender? (Cocktails/Beer/Wine)</p>
                      <div className="flex items-center gap-2 justify-between">
                        <div className=" text-xs  focus:outline-none  focus:ring-1 focus:ring-primary-red  font-semibold">
                          Guests
                        </div>
                        <SelectInput
                          classes="max-w-40"
                          bg="bg-white"
                          disabled={false}
                          value={selectedGuests}
                          onChange={(e: string) => {
                            const selectedValue = e;
                            setSelectedGuests(Number(selectedValue));
                          }}
                          options={guestsPerBartenderDrop}
                        />
                      </div>
                    </div>
                  </div>
                }
                {selectedType === 'custom_package' && <div className="flex gap-4 w-full ">
                  <div className="w-full">
                    <div className=" font-semibold text-sm flex justify-between items-center flex-col lg:flex-row bg-p-gray p-3 rounded-2xl mt-2">
                      <div className="flex flex-row gap-2 items-center flex-wrap">
                        <p>How many guests per bartender? (Beer & Wine) </p>
                        <ToggleInput
                          onChange={() => { setGPB(!GPB) }}
                        />
                      </div>
                      <div className="flex items-center gap-2 justify-between">
                        <div className=" text-xs  focus:outline-none  focus:ring-1 focus:ring-primary-red  font-semibold">
                          Guests
                        </div>
                        <SelectInput
                          classes="max-w-40"
                          bg="bg-white"
                          disabled={false}
                          value={selectedGuestBeer}
                          onChange={(e: string) => {
                            const selectedValue = e;
                            // setSelectedGuestsInput(Number(selectedValue));
                            setSelectedGuestBeer(Number(selectedValue));
                          }}
                          options={guestsPerBartenderDrop}
                        />

                      </div>
                    </div>
                  </div>
                </div>}
                <div className="w-full bg-p-gray p-3 rounded-2xl  mt-2">
                  <div className=" font-semibold text-sm flex justify-between items-center sm:mb-0 mb-2">
                    <div className="flex items-center justify-center gap-1"><p>Prep/Clean up time per event?</p><span className="text-primary-red">*</span></div>
                    <div className="flex items-center gap-2 mb-1">
                      <div className=" text-sm  font-semibold">Min</div>
                      <input
                        min="30"
                        max="240"
                        className="border text-center w-20 px-3 py-1 rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red "
                        type="number"
                        value={bartenderPrepTime}
                        onKeyDown={(e) => {
                          if (e.key === "." || e.key === "e") {
                            e.preventDefault(); // Block '.' and 'e'
                          }
                        }}
                        onChange={(e: any) => {
                          const val = e.target.value;
                          if (parseInt(val) > 240) {
                            setBartenderPrepTime(240);
                          } else {
                            if (
                              val.indexOf(".") !== -1 &&
                              val.split(".")[1].length > 2
                            ) {
                              const valFloat = Number(
                                parseFloat(e.target.value).toFixed(2)
                              );
                              setBartenderPrepTime(valFloat);
                            } else {
                              if (val >= 0) {
                                setBartenderPrepTime(e.target.value);
                              } else {
                                setBartenderPrepTime(0);
                              }
                            }
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="font-semibold text-sm w-full flex flex-col sm:flex-row  justify-between items-center bg-p-gray p-3 rounded-2xl mt-2">
                  <div className="mb-2 w-full sm:mb-0 sm:w-auto">
                    <p>Wage per hour?</p>
                  </div>
                  <div className="flex items-center font-semibold text-sm gap-4">
                    <div className="flex flex-col items-center">
                      <div className="flex items-center justify-center gap-1"><p>Cost</p><span className="text-primary-red">*</span></div>
                      <div className="flex justify-end gap-2 items-end">
                        <div className="flex items-center gap-2">
                          <input
                            className="border w-20 text-center py-1  rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red"
                            type="number"
                            value={bartenderCost}
                            min={1}
                            max={999}
                            onChange={(e: any) => {
                              const val = e.target.value;
                              if (parseInt(val) > 999) {
                                setBartenderCost(999);
                              } else if (parseInt(val) < 0) {
                                setBartenderCost(0.01);
                              } else {
                                if (
                                  val.indexOf(".") !== -1 &&
                                  val.split(".")[1].length > 2
                                ) {
                                  if (val >= 0) {
                                    const valFloat = Number(
                                      parseFloat(e.target.value).toFixed(2)
                                    );
                                    setBartenderCost(valFloat);
                                  } else {
                                    setBartenderCost(0.01);
                                  }
                                } else {
                                  if (val >= 0) {
                                    setBartenderCost(e.target.value);
                                  } else {
                                    setBartenderCost(0.01);
                                  }
                                }
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col items-center">
                      <p> Profit</p>
                      {showBpp ? (
                        <div className="flex items-center gap-2">
                          <div className="flex flex-row gap-2">
                            <input
                              min={0}
                              max={999}
                              className="border w-20 text-center py-1 rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red"
                              type="number"
                              value={bartenderPrice}
                              onChange={(e: any) => {
                                const val = e.target.value;
                                if (parseInt(val) > 999) {
                                  setBartenderPrice(999);
                                } else {
                                  if (
                                    val.indexOf(".") !== -1 &&
                                    val.split(".")[1].length > 2
                                  ) {
                                    if (val >= 0) {
                                      const valFloat = Number(
                                        parseFloat(e.target.value).toFixed(2)
                                      );
                                      setBartenderPrice(valFloat);
                                    } else {
                                      setBartenderPrice(0);
                                    }
                                  } else {
                                    if (val >= 0) {
                                      setBartenderPrice(e.target.value);
                                    } else {
                                      setBartenderPrice(0);
                                    }
                                  }
                                }
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="flex items-center gap-2">
                          <div className=" text-sm text-primary-red font-semibold">
                            %
                          </div>
                          <div className="flex flex-row gap-2">
                            <input
                              className="border w-20 text-center py-1 rounded-full  focus:border-primary-red countInput"
                              type="number"
                              value={Bpp}
                              onChange={(e: any) => {
                                const val = e.target.value;
                                if (val <= 100) {
                                  if (val >= 0) {
                                    const valFloat = Number(
                                      parseFloat(val).toFixed(2)
                                    );
                                    setBpp(valFloat);
                                    setBartenderPrice(
                                      (bartenderCost * Number(val)) / 100
                                    );
                                  } else {
                                    setBpp(0);
                                    setBartenderPrice(
                                      (bartenderCost * Number(0)) / 100
                                    );
                                  }
                                }
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="flex flex-col items-center">
                      <p>Total</p>
                      <input
                        disabled={true}
                        className="border w-20 text-center py-1  rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red"
                        type="number"
                        value={Number(bartenderCost) + Number(bartenderPrice)}
                      />
                    </div>
                  </div>
                </div>
                {/* <div className="flex gap-4 font-semibold w-full bg-p-gray p-3 rounded-2xl mt-2">
                  <p>Want to make the tip-jar mandatory?</p>
                  <div className="mt-1">
                    <ToggleInput
                      checked={tipJar}
                      onChange={() => {
                        setTipJar(!tipJar);
                      }}
                    />
                  </div>
                </div> */}
                {!tipJar && (
                  <div className="w-full bg-p-gray p-3 rounded-2xl mt-2 flex flex-row justify-between pt-5">
                    <div className="flex justify-between font-semibold text-sm flex-grow flex-col sm:flex-row sm:items-center">
                      <div className="flex gap-2">
                        <p>Bartender Tips</p>
                        <div>
                          <ToggleInput
                            checked={showBtp}
                            onChange={() => {
                              setShowBtp(!showBtp);
                            }}
                          />
                        </div>
                      </div>
                      <div className="flex flex-row justify-center gap-4">
                        <div className="flex flex-col items-center">
                          <p>Price</p>
                          {!showBtp ? (
                            <div className="flex items-center gap-2">
                              <div className=" text-sm font-semibold">
                                $
                              </div>
                              <div className="flex flex-row gap-2">
                                <input
                                  min={0}
                                  max={999}
                                  className="border text-center w-20 px-3 py-1 rounded-full focus:outline-none focus:ring-1 focus:ring-primary-red countInput"
                                  type="number"
                                  value={bartenderTips}
                                  onChange={(e: any) => {
                                    const val = e.target.value;
                                    if (parseInt(val) > 999) {
                                      setBartenderTips(999);
                                    } else if (parseInt(val) < 0) {
                                      setBartenderTips(0);
                                    } else {
                                      if (
                                        val.indexOf(".") !== -1 &&
                                        val.split(".")[1].length > 2
                                      ) {
                                        if (val >= 0) {
                                          const valFloat = Number(
                                            parseFloat(e.target.value).toFixed(2)
                                          );
                                          setBartenderTips(valFloat);
                                        } else {
                                          setBartenderTips(0);
                                        }
                                      } else {
                                        if (val >= 0) {
                                          setBartenderTips(e.target.value);
                                        } else {
                                          setBartenderTips(0);
                                        }
                                      }
                                    }
                                  }}
                                />
                              </div>
                            </div>
                          ) : (
                            <div className="flex items-center gap-2">
                              <div className=" text-sm font-semibold">
                                %
                              </div>
                              <div className="flex flex-row gap-2">
                                <input
                                  className="border text-center w-20 px-3 py-1 rounded-full focus:outline-none focus:ring-1 focus:ring-primary-red countInput"
                                  type="number"
                                  value={btp}
                                  onChange={(e: any) => {
                                    const val = e.target.value;
                                    if (val <= 100) {
                                      if (val >= 0) {
                                        const valFloat = Number(
                                          parseFloat(val).toFixed(2)
                                        );
                                        setbtp(valFloat);
                                      } else {
                                        setbtp(0);
                                      }
                                    }
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="flex items-center flex-col">
                          <p>Min Tip</p>
                          <div className="flex items-center gap-2">
                            <div className=" text-sm d font-semibold">$</div>
                            <input
                              min="0"
                              max="5000"
                              className="border text-center w-20 px-3 py-1  rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red"
                              type="number"
                              value={minBartenderTip}
                              onChange={(e: any) => {
                                const val = e.target.value;
                                if (parseInt(val) > 5000) {
                                  setMinBartenderTip(5000);
                                } else {
                                  if (
                                    val.indexOf(".") !== -1 &&
                                    val.split(".")[1].length > 2
                                  ) {
                                    const valFloat = Number(
                                      parseFloat(e.target.value).toFixed(2)
                                    );
                                    if (valFloat >= 0) {
                                      setMinBartenderTip(valFloat);
                                    } else {
                                      setMinBartenderTip(0);
                                    }
                                  } else {
                                    if (val >= 0) {
                                      setMinBartenderTip(e.target.value);
                                    } else {
                                      setMinBartenderTip(0);
                                    }
                                  }
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              </div>
            </div>
            {selectedType !== 'custom_package' && <div className={`${selectedType === "custom_package" && width >= 767 ? 'visible' : 'hidden'} w-full mr-2 bg-white rounded-2xl  p-5  mt-4`}>
              <div className=" font-semibold my-2 flex justify-between items-center ">
                <p>{"Package Description"}</p>
              </div>
              <div className="flex">
                <textarea
                  disabled={false}
                  rows={12}
                  onChange={(e) => setSupplyDescription(e.target.value)}
                  className={`max-h-32 w-full px-4 py-3 bg-p-gray rounded-xl    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600`}
                  placeholder={""}
                  value={supplyDescription}
                />
              </div>
            </div>}
            {selectedType !== 'custom_package' && <div className="w-full bg-white rounded-2xl p-5">
              <p className="md:text-xl text-lg font-bold">
                About your Cocktails
              </p>
              <div className="flex flex-col p-3bg-p-gray rounded-2xl mt-2">
                <div className="w-full">
                  <div className="flex justify-between items-center font-semibold text-sm flex-col sm:flex-row">
                    <div className="mb-2 w-full sm:mb-0 sm:w-auto">
                      <p>Price Per Cocktail</p>
                    </div>
                    <div className="flex flex-row gap-4">
                      <div className="flex flex-col items-center">
                        <div className="flex items-center justify-center gap-1"><p>Cost</p><span className="text-primary-red">*</span></div>
                        <input
                          min={0}
                          max={999}
                          className="border w-20 text-center py-1 rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red countInput"
                          type="number"
                          title=""
                          value={suppliesCosts}
                          onChange={(e: any) => {
                            const val = e.target.value;
                            if (parseInt(val) > 999) {
                              setSuppliesCosts(999);
                            } else if (parseInt(val) < 0) {
                              setSuppliesCosts(0.01);
                            } else {
                              if (
                                val.indexOf(".") !== -1 &&
                                val.split(".")[1].length > 2
                              ) {
                                if (val >= 0) {
                                  const valFloat = Number(
                                    parseFloat(e.target.value).toFixed(2)
                                  );
                                  setSuppliesCosts(valFloat);
                                } else {
                                  setSuppliesCosts(0.01);
                                }
                              } else {
                                if (val >= 0) {
                                  setSuppliesCosts(e.target.value);
                                } else {
                                  setSuppliesCosts(0.01);
                                }
                              }
                            }
                          }}
                        />
                      </div>
                      <div className="flex flex-col items-center">
                        <p>Profit</p>
                        {/* <ToggleInput
                              onChange={() => {
                                setShowCSP(!showCSP);
                                if (!showCSP) {
                                  console.log("showCSP", showCSP);
                                  setSuppliesPrice(0);
                                }
                                if (suppliesCosts >= 0) {
                                  setSuppliesPrice((suppliesCosts * SPP) / 100);
                                } else {
                                  setSuppliesPrice(0);
                                }
                              }}
                            /> */}
                        {showCSP ? (
                          <div className="flex items-center gap-2">
                            <input
                              className="border w-20 text-center py-1 rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red countInput"
                              type="number"
                              value={suppliesPrice}
                              min={0}
                              max={999}
                              onChange={(e: any) => {
                                const val = e.target.value;
                                if (parseInt(val) > 999) {
                                  setSuppliesPrice(999);
                                } else {
                                  if (
                                    val.indexOf(".") !== -1 &&
                                    val.split(".")[1].length > 2
                                  ) {
                                    if (val >= 0) {
                                      const valFloat = Number(
                                        parseFloat(e.target.value).toFixed(2)
                                      );
                                      setSuppliesPrice(valFloat);
                                    } else {
                                      setSuppliesPrice(0);
                                    }
                                  } else {
                                    if (val >= 0) {
                                      setSuppliesPrice(e.target.value);
                                    } else {
                                      setSuppliesPrice(0);
                                    }
                                  }
                                }
                              }}
                            />
                          </div>
                        ) : (
                          <div className="flex items-center gap-2">
                            <div className=" text-sm text-primary-red font-semibold">
                              %
                            </div>
                            <input
                              className="border w-20 px-3 py-1 rounded-full   focus:border-primary-red countInput"
                              type="number"
                              value={SPP}
                              min={0}
                              max={100}
                              onChange={(e: any) => {
                                const val = e.target.value;
                                if (val <= 100) {
                                  if (val >= 0) {
                                    const valFloat = Number(
                                      parseFloat(val).toFixed(2)
                                    );
                                    setSPP(valFloat);
                                    setSuppliesPrice(
                                      (suppliesCosts * Number(val)) / 100
                                    );
                                  } else {
                                    setBpp(0);
                                    setSuppliesPrice(
                                      (suppliesCosts * Number(0)) / 100
                                    );
                                  }
                                }
                              }}
                            />
                          </div>
                        )}
                      </div>
                      <div className="flex flex-col items-center">
                        <p>Total</p>
                        <input
                          disabled={true}
                          className="border w-20 text-center py-1 rounded-full focus:border-primary-red countInput"
                          type="number"
                          value={(Number(suppliesCosts) + Number(suppliesPrice))}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                </div>
              </div>
            </div>}
            {selectedType !== 'custom_package' && <div className="w-full bg-white rounded-2xl p-5">
              <div className=" font-semibold my-2 flex justify-between items-center">
                <div className="flex items-center justify-center gap-1"><p>{"What's included in your package?"}</p><span className="text-primary-red">*</span></div>
                <FaCirclePlus
                  className="cursor-pointer text-gray-400 text-xl"
                  onClick={() => setAddSupplyForm(true)}
                />
              </div>
              <div className="flex w-fit flex-wrap gap-3 pr-2 mt-4 overflow-y-auto overflow-x-auto max-w-100 max-h-52">
                {totalSuppliesList.map((item, index) => {
                  return (
                    <div key={index}>
                      <button
                        type="button"
                        onClick={() =>
                          selectSupply(selectedSupplies.includes(item), item)
                        }
                        className={`${selectedSupplies.includes(item)
                          ? "bg-primary-red text-white"
                          : "bg-gray-200 text-black"
                          }  rounded-full px-3 py-1 cursor-pointer`}
                      >
                        {item}
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>}
          </div>
          <div className="flex flex-col gap-5 mb-5 md:w-3/6">

            <div className="w-full bg-white rounded-2xl p-5 flex-col">
              <p className="md:text-xl text-lg font-bold mb-2 mt-2">
                About your Business
              </p>
              <div className=" font-semibold text-sm flex justify-between bg-p-gray p-3 rounded-2xl">
                <p>Additional Profit</p>
                <div className="flex items-center gap-2">
                  <div className=" text-sm  font-semibold">$</div>
                  <input
                    min="0"
                    max="5000"
                    className="border w-20 px-3 py-1 text-center rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red  "
                    type="number"
                    value={additionalProfit}
                    onChange={(e: any) => {
                      const val = e.target.value;
                      if (parseInt(val) > 5000) {
                        setAdditionalProfit(5000);
                      } else {
                        if (
                          val.indexOf(".") !== -1 &&
                          val.split(".")[1].length > 2
                        ) {
                          const valFloat = Number(
                            parseFloat(e.target.value).toFixed(2)
                          );
                          if (valFloat >= 0) {
                            setAdditionalProfit(valFloat);
                          } else {
                            setAdditionalProfit(0);
                          }
                        } else {
                          if (val >= 0) {
                            setAdditionalProfit(e.target.value);
                          } else {
                            setAdditionalProfit(0);
                          }
                        }
                      }
                    }}
                  />
                </div>
              </div>
              <div className="font-semibold text-sm flex justify-between items-center bg-p-gray p-3 rounded-2xl mt-2 flex-col lg:flex-row">
                <div className="mb-2 w-full sm:mb-0 lg:w-auto">
                  <p>Expense</p>
                </div>
                <div className="flex flex-row gap-4">
                  <div className="flex items-center flex-col">
                    <div className="flex items-center justify-center gap-1"><p>Fixed</p><span className="text-primary-red">*</span></div>
                    <div className="flex items-center">
                      <input
                        min="1"
                        max="5000"
                        className="border w-20 py-1 rounded-full text-center focus:outline-none  focus:ring-1 focus:ring-primary-red"
                        type="number"
                        value={deliveryCost}
                        onChange={(e: any) => {
                          const val = e.target.value;
                          if (parseInt(val) > 5000) {
                            setDeliveryCost(5000);
                          } else if (parseInt(val) < 0) {
                            setDeliveryCost(0.01);
                          } else {
                            if (
                              val.indexOf(".") !== -1 &&
                              val.split(".")[1].length > 2
                            ) {
                              const valFloat = Number(
                                parseFloat(e.target.value).toFixed(2)
                              );
                              if (valFloat >= 0) {
                                setDeliveryCost(valFloat);
                              } else {
                                setDeliveryCost(0.01);
                              }
                            } else {
                              if (val >= 0) {
                                setDeliveryCost(e.target.value);
                              } else {
                                setDeliveryCost(0.01);
                              }
                            }
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex items-center flex-col">
                    <p>Insurance</p>
                    <div className="flex items-center gap-2">
                      <input
                        min="0"
                        max="5000"
                        className="border w-20 text-center py-1 rounded-full  focus:outline-none  focus:ring-1 focus:ring-primary-red"
                        type="number"
                        value={insuranceExpense}
                        onChange={(e: any) => {
                          const val = e.target.value;
                          if (parseInt(val) > 5000) {
                            setInsuranceExpense(5000);
                          } else {
                            if (
                              val.indexOf(".") !== -1 &&
                              val.split(".")[1].length > 2
                            ) {
                              const valFloat = Number(
                                parseFloat(e.target.value).toFixed(2)
                              );
                              if (valFloat >= 0) {
                                setInsuranceExpense(valFloat);
                              } else {
                                setInsuranceExpense(0);
                              }
                            } else {
                              if (val >= 0) {
                                setInsuranceExpense(e.target.value);
                              } else {
                                setInsuranceExpense(0);
                              }
                            }
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex items-center flex-col">
                    <p>Marketing</p>
                    <div className="flex items-center gap-2">
                      <input
                        min="0"
                        max="5000"
                        className="border w-20 text-center py-1 rounded-full  focus:outline-none  focus:ring-1 focus:ring-primary-red"
                        type="number"
                        value={marketingExpense}
                        onChange={(e: any) => {
                          const val = e.target.value;
                          if (parseInt(val) > 5000) {
                            setMarketingExpense(5000);
                          } else {
                            if (
                              val.indexOf(".") !== -1 &&
                              val.split(".")[1].length > 2
                            ) {
                              const valFloat = Number(
                                parseFloat(e.target.value).toFixed(2)
                              );
                              if (valFloat >= 0) {
                                setMarketingExpense(valFloat);
                              } else {
                                setMarketingExpense(0);
                              }
                            } else {
                              if (val >= 0) {
                                setMarketingExpense(e.target.value);
                              } else {
                                setMarketingExpense(0);
                              }
                            }
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-between items-center font-semibold text-sm bg-p-gray p-3 rounded-2xl mt-2">
                <div className="flex items-center justify-center gap-1"><p>{"Minimum package time?"}</p><span className="text-primary-red">*</span></div>
                <div className="flex items-center gap-2">
                  <div className=" text-sm d font-semibold">Hr</div>
                  <input
                    min="30"
                    max="250"
                    className="border w-20 px-3 py-1 text-center rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red"
                    type="number"
                    title=""
                    value={minPackageTime}
                    onChange={(e: any) => {
                      const val = e.target.value;
                      if (e.target.value > 12) {
                        setMinPackageTime(12);
                        setHrToRegister(12);
                      } else {
                        if (val.indexOf(".") == -1) {
                          if (val > 0) {
                            setMinPackageTime(e.target.value);
                            setHrToRegister(e.target.value);
                          } else {
                            setMinPackageTime(1);
                            setHrToRegister(1);
                          }
                        }
                      }
                    }}
                  />
                </div>
              </div>
              <div className="flex justify-between items-center font-semibold text-sm bg-p-gray p-3 rounded-2xl mt-2">
                <p>Minimum Price</p>
                <div className="flex items-center gap-2">
                  <div className=" text-sm d font-semibold">$</div>
                  <input
                    min="0"
                    max="5000"
                    className="border w-20 px-3 py-1 text-center rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red"
                    type="number"
                    value={minPackagePrice}
                    onChange={(e: any) => {
                      const val = e.target.value;
                      if (e.target.value > 0) {
                        setHrToRegister(1);
                        setMinPackageTime(1);
                      }
                      if (parseInt(val) > 5000) {
                        setMinPackagePrice(5000);
                      } else {
                        if (
                          val.indexOf(".") !== -1 &&
                          val.split(".")[1].length > 2
                        ) {
                          const valFloat = Number(
                            parseFloat(e.target.value).toFixed(2)
                          );
                          if (valFloat >= 0) {
                            setMinPackagePrice(valFloat);
                            if (valFloat == 0) {
                              setMinPackageTime(3);
                              setHrToRegister(3);
                            }
                          } else {
                            setMinPackagePrice(0);
                          }
                        } else {
                          if (val >= 0) {
                            setMinPackagePrice(e.target.value);
                            if (val == 0) {
                              setMinPackageTime(3);
                              setHrToRegister(3);
                            }
                          } else {
                            setMinPackagePrice(0);
                          }
                        }
                      }
                    }}
                  />
                </div>
              </div>
            </div>


            <div className="w-full bg-white rounded-2xl  p-5  ">
              <div className="flex items-center justify-between">
                <p className="md:text-xl text-lg font-bold mb-2 mt-2">
                  Add-ons
                </p>
                <div className="flex items-center text-black ">
                  <FaCirclePlus
                    className="cursor-pointer text-gray-400 text-xl"
                    onClick={() => {
                      setAddOnIsEdit(false);
                      setAddOnName("");
                      setAddOnImage({ img: "" });
                      setAddOnPrice("");
                      setAddOnCost("");
                      setAddOnMinPrice("");
                      setAddOnType("bartender");
                      setAddOnDesc("");
                      setAddOnForm(true);
                      setIncludeInPackage(false);
                      setAddOnPrepTime(false);
                    }}
                  />
                </div>
              </div>
              {addOns.filter((a) => {
                return a.is_btc_edit === false;
              }).length ? <>
                <p className="font-semibold mb-2">Mandatory</p>
                <div className="flex flex-col gap-4 bg-p-gray p-3 rounded-2xl">
                  <div className="flex gap-4">
                    <div className="flex flex-col flex-wrap gap-2 w-full p-x-10">
                      {addOns.filter((a) => {
                        return a.is_btc_edit === false;
                      })
                        .map((i, index) => {
                          return (
                            <div key={i.id} className="flex items-center gap-2 justify-between">
                              <div className="flex gap-2">
                                {i?.img ? <img className="w-14 h-14 rounded-md" src={i?.img} alt="" /> :
                                  i?.addonImage ? <img className="w-14 h-14 rounded-md" src={i?.addonImage.img} alt="" /> : ''
                                }
                                <div>

                                  <h1
                                    key={i.id}
                                    className="flex items-center  font-semibold text-gray-500"
                                  >
                                    {/* <span className=" rounded-full bg-primary-red w-1 h-3 inline-block"></span>{" "} */}
                                    {i.name}

                                  </h1>

                                  <p className="font-semibold text-gray-500">
                                    $ {USFormatePriceWithoutDecimal(
                                      (
                                        getAddonPrice(
                                          i,
                                          guest,
                                          numberOfBartenders,
                                          hrToRegister,
                                          bartenderPrepTime
                                        ) / 100
                                      ).toFixed(2)
                                    )}
                                  </p>
                                </div>

                              </div>

                              <div className="flex gap-2 items-center">

                                {roles == 'admin' &&
                                  <ToggleInput
                                    // disabled={roles !=='admin'}
                                    disabled={(i.is_btc_edit === false && !roles)}

                                    onChange={() => {
                                      setAddOns((prev) => {
                                        const value = prev.map((item) => {
                                          if (item.id === i.id) {
                                            return {
                                              ...item,
                                              auto_include: !item.auto_include,
                                            };
                                          }
                                          return item;
                                        });
                                        setSupplyDescription(
                                          `${generateDescription(
                                            selectedSupplies
                                          )}\n${generateAddsOnDescription([...value])}`
                                        );
                                        return value;
                                      });
                                    }}
                                    checked={i.auto_include}
                                  />
                                }
                                {
                                  // true
                                  // (roles ==='admin' || (roles !== 'admin' && !i.is_btc_edit) )
                                  ((i.is_btc_edit === true && !roles) || roles === 'admin')
                                  &&
                                  <div
                                    data-testid="delete-icon "
                                    className="p-2 bg-p-gray rounded-full font-bold cursor-pointer "
                                    onClick={() => {
                                      deleteAddOn(i.id as string);
                                    }}
                                  >
                                    <img src={deleteIcon} className="min-w-3" />
                                  </div>}
                                {i.id && (
                                  <div
                                    className="cursor-pointer flex gap-3 bg-p-gray rounded-full p-2 "
                                    onClick={() => editAddonForm(i)}
                                  >
                                    <FiEdit2 size={14} />
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </> : ''}

              {addOns.filter((a) => {
                return a.is_btc_edit === true;
              }).length > 0 && <>
                  <p className="font-semibold mt-2">Optional</p>
                  <div className="flex flex-col gap-4 bg-p-gray p-3 rounded-2xl mt-3">
                    <div className="flex gap-4">
                      <div className="flex flex-col flex-wrap gap-2 w-full p-x-10">
                        {addOns.filter((a) => {
                          return a.is_btc_edit === true;
                        })
                          .map((i, index) => {
                            return (
                              <div key={i.id} className="flex items-center gap-2 justify-between">
                                <div className="flex gap-2">
                                  {i?.img ? <img className="w-14 h-14 rounded-md" src={i?.img} alt="" /> :
                                    i?.addonImage ? <img className="w-14 h-14 rounded-md" src={i?.addonImage.img} alt="" /> : ''
                                  }
                                  <div>

                                    <h1
                                      key={i.id}
                                      className="flex items-center  font-semibold text-gray-500"
                                    >
                                      {/* <span className=" rounded-full bg-primary-red w-1 h-3 inline-block"></span>{" "} */}
                                      {i.name}

                                    </h1>

                                    <p className="font-semibold text-gray-500">
                                      $ {USFormatePriceWithoutDecimal(
                                        (
                                          getAddonPrice(
                                            i,
                                            guest,
                                            numberOfBartenders,
                                            hrToRegister,
                                            bartenderPrepTime
                                          ) / 100
                                        ).toFixed(2)
                                      )}
                                    </p>
                                  </div>

                                </div>

                                <div className="flex gap-2 items-center">

                                  <ToggleInput
                                    // disabled={roles !=='admin'}
                                    disabled={(i.is_btc_edit === false && !roles)}

                                    onChange={() => {
                                      setAddOns((prev) => {
                                        const value = prev.map((item) => {
                                          if (item.id === i.id) {
                                            return {
                                              ...item,
                                              auto_include: !item.auto_include,
                                            };
                                          }
                                          return item;
                                        });
                                        setSupplyDescription(
                                          `${generateDescription(
                                            selectedSupplies
                                          )}\n${generateAddsOnDescription([...value])}`
                                        );
                                        return value;
                                      });
                                    }}
                                    checked={i.auto_include}
                                  />
                                  {
                                    // true
                                    // (roles ==='admin' || (roles !== 'admin' && !i.is_btc_edit) )
                                    ((i.is_btc_edit === true && !roles) || roles === 'admin')
                                    &&
                                    <div
                                      data-testid="delete-icon "
                                      className="p-2 bg-p-gray rounded-full font-bold cursor-pointer "
                                      onClick={() => {
                                        deleteAddOn(i.id as string);
                                      }}
                                    >
                                      <img src={deleteIcon} className="min-w-3" />
                                    </div>}
                                  {i.id && (
                                    <div
                                      className="cursor-pointer flex gap-3 bg-p-gray rounded-full p-2 "
                                      onClick={() => editAddonForm(i)}
                                    >
                                      <FiEdit2 size={14} />
                                    </div>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </>}

            </div>
            <FormModal
              overflow="overflow-hidden "
              modalTitle={addOnIsEdit ? "Update Add-on" : "Create Add-on"}
              isOpen={addAddOnForm}
              width="lg:w-3/6 md:w-5/6 w-full"
              height="overflow-y-auto"
              onClose={closeAddOnModal}
            >
              <div className="mt-2 px-3">
                {/* <div className="text-end text-xs font-semibold mb-1">
                  Per Add-on: $
                  {(
                    Number(addOnPrice ? addOnPrice : 0) +
                    Number(addOnCost ? addOnCost : 0)
                  ).toFixed(2)}{" "}
                </div> */}
                <div className="flex gap-4 justify-between sm:items-start flex-col sm:flex-row items-center">
                  <div className="flex-2 ">
                    <Dropzone
                      image={addOnImage?.img !== "undefined" && addOnImage?.img}
                      imgStyle={"w-24 h-24 rounded-xl"}
                      removeImage={() => removeAddOnImage()}
                      onDrop={uploadAddOnImg}
                    // classname="w-20 h-20 py-2 mr-2 rounded-xl object-cover"
                    ></Dropzone>
                  </div>

                  <div className="flex flex-col gap-1 w-full  flex-grow ">
                    <div className="flex gap-2 flex-col  sm:flex-row">
                      <div className="w-full">
                        <p className="font-semibold mb-1">Name:</p>
                        <input
                          disabled={(!isEditByBtC && !roles && addOnIsEdit)}
                          className="w-full px-4 py-3 bg-p-gray rounded-full focus:outline-none focus:ring-1 focus:ring-primary-red text-gray-600"
                          maxLength={50}
                          value={addOnName}
                          onChange={(e) => setAddOnName(e.target.value)}
                          type="text"
                          placeholder="Name"
                        />
                      </div>
                      <div className="w-full">
                        <p className="font-semibold mb-1">Types:</p>
                        <SelectInput
                          border="none"
                          classes="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                          rounded="rounded-full"
                          options={addOnsTypes}
                          value={addOnType}
                          onChange={(selectedValue: string) => {
                            setAddOnType(selectedValue);
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <p className="font-semibold mb-1">Description:</p>
                        <input
                          // disabled={addOnName === portableBar || addOnName === iceCubes}
                          maxLength={200}
                          className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                          value={addOnDesc}
                          onChange={(e) => setAddOnDesc(e.target.value)}
                          type="text"
                          placeholder="Description"
                        />
                      </div>
                    </div>
                    <div className="flex gap-2 flex-col sm:flex-row">
                      <div className="w-full">
                        <p className="font-semibold mb-1">Cost:</p>
                        <input
                          value={addOnCost}
                          className="w-full px-4 py-3 bg-p-gray rounded-full focus:outline-none focus:ring-1 focus:ring-primary-red text-gray-600"
                          type="number"
                          placeholder="Cost"
                          step={0.01}
                          max={999}
                          // onChange={(e) => setAddOnCost(e.target.value)}
                          onChange={(e: any) => {
                            const val = e.target.value; // Use `const` instead of `let`
                            if (parseFloat(val) > 999) {
                              setAddOnCost("999");
                            } else if (parseFloat(val) < 0) {
                              setAddOnCost("0.01");
                            } else if (val.includes(".") && val.split(".")[1].length > 2) {
                              setAddOnCost(parseFloat(val).toFixed(2).toString());
                            }
                            else if (val === '0' || parseFloat(val) < 0.01) {
                              setAddOnCost(val.toString());
                              // setCanSubmit(false)
                            }
                            else {
                              setAddOnCost(val.toString());
                            }

                            // change submit button action
                            // if(parseFloat(val)>0.01 && parseFloat(addOnPrice) >=0 ){
                            if (parseFloat(val) >= 0 && parseFloat(addOnPrice) >= 0) {
                              // setCanSubmit(true)
                            }
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <p className="font-semibold mb-1">Profit:</p>
                        <input
                          value={addOnPrice}
                          className="w-full px-4 py-3 bg-p-gray rounded-full focus:outline-none focus:ring-1 focus:ring-primary-red text-gray-600"
                          type="number"
                          placeholder="Profit"
                          step={0.01}
                          max={999}
                          // onChange={(e) => setAddOnPrice(e.target.value)}
                          onChange={(e: any) => {
                            const val = e.target.value; // Use `const` instead of `let`
                            if (parseFloat(val) > 999) {
                              setAddOnPrice("999");
                            } else if (parseFloat(val) < 0) {
                              setAddOnPrice("0.01");
                            } else if (val.includes(".") && val.split(".")[1].length > 2) {
                              setAddOnPrice(parseFloat(val).toFixed(2).toString());
                            }
                            else if (val === '0') {
                              // setCanSubmit(false)
                              setAddOnPrice(val.toString());

                            }
                            else {
                              setAddOnPrice(val.toString());
                            }
                            // profit cannot be zero
                            // if(parseFloat(val) >=0 && parseFloat(addOnCost) > 0.01){
                            if (parseFloat(val) >= 0 && parseFloat(addOnCost) >= 0) {
                              // setCanSubmit(true)
                            }
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <p className="font-semibold mb-1">Total:</p>
                        <input
                          value={(
                            Number(addOnPrice ? addOnPrice : 0) +
                            Number(addOnCost ? addOnCost : 0)
                          ).toFixed(2)}
                          className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                          type="number"
                          placeholder="Pre Add-on"
                          step={0.01}
                          max={999}
                          disabled={true}
                        />
                      </div>
                    </div>
                    {/**add cost above it*/}
                    <div className="flex gap-2 flex-col sm:flex-row">
                      <div className="w-full">
                        <p className="font-semibold mb-1">Minimun Price:</p>
                        <input
                          value={addOnMinPrice}
                          className="w-full px-4 py-3 bg-p-gray rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                          type="number"
                          placeholder="Minimum Price"
                          step={0.01}
                          max={999}
                          onChange={(e: any) => {
                            const val = e.target.value;
                            if (parseFloat(val) > 999) {
                              setAddOnMinPrice("999");
                            } else if (parseFloat(val) < 0) {
                              setAddOnMinPrice("0");
                            } else if (val.includes(".") && val.split(".")[1].length > 2) {
                              setAddOnMinPrice(parseFloat(val).toFixed(2).toString());
                            }
                            else {
                              setAddOnMinPrice(val.toString());
                            }
                          }}
                        />
                      </div>
                      <div className="w-full gap-2 flex justify-start items-center pt-7">
                        <Input
                          disabled={(isEditByBtC === false && !roles && addOnIsEdit)}
                          className="cursor-pointer w-4 accent-primary-red"
                          type="checkbox"
                          checked={includeInPackage}
                          onChange={(e) =>
                            setIncludeInPackage(!includeInPackage)
                          }
                        />
                        <label htmlFor="">Include in Package</label>
                      </div>
                      {addOnType == 'hourly' ?
                        <div className="w-full gap-2 flex justify-start items-center pt-7 ml-0 sm:ml-2">
                          <Input
                            className="cursor-pointer w-4 accent-primary-red"
                            type="checkbox"
                            checked={addOnPrepTime}
                            onChange={(e) =>
                              setAddOnPrepTime(!addOnPrepTime)
                            }
                          />
                          <label htmlFor="">Prep/Clean up time</label>
                        </div> :
                        <div className="w-full gap-2 flex justify-start items-center pt-7 ml-0 sm:ml-2">
                        </div>
                      }
                    </div>
                  </div>
                </div>
                {addOnError && (
                  <p className="text-primary-red text-xs ">{addOnError}</p>
                )}
                <div className="flex justify-end mb-5 md:mb-0">
                  <Button
                    disabled={!canSubmit}
                    type="button"
                    classes={` ${!canSubmit ? 'bg-gray-400' : 'bg-primary-red'} text-sm text-white rounded px-3 py-2 cursor-pointer`}
                    onClick={addOnIsEdit ? updateAddOn : addAddOn}
                  >
                    {addOnIsEdit ? "Update" : "Add"}
                  </Button>
                </div>
              </div>
            </FormModal>
          </div>
        </div>
        <div className={`${selectedType !== 'custom_package' ? 'visible' : 'hidden'} md:w-3/6 w-full mr-2 bg-white rounded-2xl  p-5  mt-4`}>
          <div className=" font-semibold my-2 flex justify-between items-center ">
            <p>{"Package Description"}</p>
          </div>
          <div className="flex">
            <textarea
              disabled={false}
              rows={12}
              onChange={(e) => setSupplyDescription(e.target.value)}
              className={`w-full px-4 py-3 bg-p-gray rounded-xl    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600`}
              placeholder={""}
              value={supplyDescription}
            />
          </div>
        </div>
        {selectedType === 'custom_package' && <CustomSupplies supplies={customSupplies} editDefaultSupplyPrice={editDefaultSupplyPrice} customSupplyTotal={customSupTotalPlus} />}
        <div className="flex justify-end items-center ">
          <button
            disabled={!canSubmit}
            className={`mt-3 text-white rounded-full px-4 py-2 w-fit ${!canSubmit ? 'bg-gray-400' : 'bg-primary-red'}`}
            onClick={
              params?.isCompanyCreation
                ? () => setModal(true)
                : updatePackage
            }>
            {isLoading ? (
              <Loader color="bg-gray-50 " />
            ) : curPackage && curPackage.id ? (
              "Update package"
            ) : (
              "Create Package"
            )}
          </button>
        </div>
      </div>
      <FormModal
        overflow="overflow-hidden "
        modalTitle={"Add New Package"}
        isOpen={addNewPackageForm}
        width="lg:w-3/6 md:w-5/6 w-full"
        height="overflow-y-auto"
        onClose={() => setAddNewPackageForm(false)}>
        <div className="container mx-auto p-4 md:min-h-64  md:min-h-64 min-h-96 ">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <div className="w-full ">
              <div className=" font-semibold mb-2">Package Name *</div>
              <FormHookInput
                disabled={selectedType === 'custom_package'}
                updatedStyle="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                type="text"

                maxLength={100}
                placeholder="Package Name"
                register={register("packageName", {
                  maxLength: {
                    value: 100,
                    message: "Package Name can't be more than 100 characters.",
                  },
                  pattern: avoidEmptyStringValidator,
                  required: "Package Name is required",
                })}
                error={packageFormErrors.packageName}
              />
            </div>
            <div>
              <div className="w-full">
                <div className="font-semibold mb-2">Type </div>
                <SelectSearchInput
                  disabled={false}
                  options={PACKAGES_TYPES}
                  value={selectedType}
                  onChange={(selectedValue: string) => {
                    setSelectedType(selectedValue);
                  }}
                />

                {error?.name === "type" && (
                  <p className="text-primary-red text-xs ">{error.message}</p>
                )}
              </div>
            </div>
          </div>
          <div className="flex justify-end mt-2 ">
            <p
              className="text-sm text-white rounded-full px-5 py-2 bg-primary-red cursor-pointer"
              onClick={() => addNewPackagefn()}
            >
              {"Add"}
              {/* {curPackage && curPackage.id ? "Add" : "Update"} */}
            </p>
          </div>
        </div>
      </FormModal>
      <FormModal
        overflow="overflow-hidden "
        modalTitle={"Edit Package"}
        isOpen={packageFormEditForm}
        width="lg:w-3/6 md:w-5/6 w-full "
        height="overflow-y-auto "
        onClose={() => setPackageFormEditForm(false)}
      >
        <div className="container mx-auto p-4 md:min-h-64 min-h-96 ">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <div className="w-full ">
              <div className=" font-semibold mb-2">Package Name *</div>
              <FormHookInput
                disabled={selectedType === 'custom_package'}
                updatedStyle="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                type="text"
                maxLength={100}
                placeholder="Package Name"
                register={register("packageName", {
                  maxLength: {
                    value: 100,
                    message: "Package Name can't be more than 100 characters.",
                  },
                  pattern: avoidEmptyStringValidator,
                  required: "Package Name is required",
                })}
                error={packageFormErrors.packageName}
              />
            </div>
            <div>
              <div className="w-full">
                <div className="font-semibold mb-2">Type </div>
                <SelectSearchInput
                  disabled={false}
                  options={PACKAGES_TYPES}
                  value={selectedType}
                  onChange={(selectedValue: string) => {
                    setSelectedType(selectedValue);
                  }}
                />

                {error?.name === "type" && (
                  <p className="text-primary-red text-xs ">{error.message}</p>
                )}
              </div>
            </div>
          </div>
          <div className="flex justify-end mt-2 ">
            <div className="flex gap-4 font-semibold  w-full items-center">
              <p className="mt-[-4px]">Package Status</p>
              <ToggleInput
                checked={activeStatus}
                onChange={() => {
                  setActiveStatus(!activeStatus);
                }}
              />
            </div>
            <p
              className="text-sm text-white rounded-full px-5 py-2 bg-primary-red cursor-pointer"
              onClick={() => addNewPackagefn()}
            >
              {"Update"}
            </p>
          </div>
        </div>
      </FormModal>
      {addSupplyForm && (
        <FormModal
          overflow="overflow-hidden "
          modalTitle="Add Supply"
          isOpen={addSupplyForm}
          width="lg:w-3/6 md:w-5/6 w-full"
          height="overflow-y-auto"
          onClose={() => {
            setAddSupplyForm(false);
            setAddError("");
          }}
        >
          <div className="w-full ">
            <div className="font-semibold my-2">Supply Name</div>
            <input
              className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
              maxLength={50}
              value={supplyInput}
              onChange={(e) => {
                setSupplyInput(e.target.value);
              }}
              onFocus={() => {
                setAddError("");
              }}
              type="text"
              placeholder="Supply Name"
            />
            {addError && (
              <p className="text-primary-red text-xs ">{addError}</p>
            )}
            <div className="flex justify-end mt-2 ">
              {/* <Button type="button" onClick={addNewSupply}>
                        Add
                      </Button> */}
              <p
                className="text-sm text-white rounded-full px-5 py-2 bg-primary-red cursor-pointer"
                onClick={() => addNewSupplyTab()}
              >
                Add
              </p>
            </div>
          </div>
        </FormModal>
      )}
      <ChangesAlert
        title={"Save Changes"}
        desc={`Are you sure you want to save this changes?`}
        positiveButtonText={"Yes"}
        negativeButtonText={"Cancel"}
        handleDiscardChanges={() => {
          setModal(false);
        }}
        handleSaveChanges={updatePackage}
        isOpen={modal}
      />
      <ChangesAlert
        title={"Delete Package"}
        desc={`Are you sure you want to delete this package?`}
        isLoading={deleteLoader}
        positiveButtonText={"Yes"}
        negativeButtonText={"Cancel"}
        handleDiscardChanges={() => {
          setDeleteModal(false);
          setDeletePackageId('');
        }}
        handleSaveChanges={() => deletePackage(deletePackageId)}
        isOpen={deleteModal}
      />
    </div>
  );
};
export default PriceCalculation;